import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, Subject, interval } from 'rxjs';
import { environment, environment_msg } from 'src/environments/environment';
import { CkEditorConfig } from '../config/ckeditor-config';
import { agendaList, MinutesCollabDetails, MeetingCollabDetails, MeetingResponse, speechToTextDetails, AttendeeCollabDetails } from '../models/basicMeetingModel';
import { Globals } from './global';
import { MeetingService } from './meeting.service';
import { UtilityService } from './utility.service';

//import 'src/assets/jquery/at.js';
import 'src/assets/jquery/jquery.atwho.js';
import 'src/assets/jquery/jquery.caret.js';
import { AttendeeService } from './attendee.service';
import { Popover } from 'bootstrap';
import { FreeFormCommonService } from './free-form-common.service';
import { NotifierService } from 'angular-notifier';
import { WebsocketTransferService } from './websocket-transfer.service';
import { compileInjectable } from '@angular/compiler';
import { InstantParticipantsComponent } from '../components/instant-participants/instant-participants.component';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FreeFormMinutesService } from './free-form-minutes.service';
import { PermissionService } from './permission.service';
import { SideNavServiceService } from './side-nav-service.service';
import { AgoraConfigService } from 'src/AgoraConfigService';


declare var CKEDITOR: any;
declare var $: any;
var taskMinuteId: string;
declare let joinConversationButton: any;
@Injectable({
  providedIn: 'root'
})
export class FreeFormAgendaService {
  minCkEditorConfig: any;
  reAssignUserId: any

  assignedTo: any;
  updatedAgendaEditbox: any;
  flattenedDTOs?: agendaList[] = []; // Flattened array of DTOs
  groupedDTOs?: agendaList[] = []; // Array to store grouped DTOs
  collabAgList = <agendaList>{};
  collabAudioList = <AttendeeCollabDetails>{};
  agoraConfigObject: any;

  constructor(private sideNav: SideNavServiceService, private permissionService: PermissionService, private injector: Injector, private dialog: MatDialog, private webTranService: WebsocketTransferService, private notifier: NotifierService, private utilService: UtilityService, private globals: Globals, private meetingService: MeetingService, private attendeeService: AttendeeService, private commonService: FreeFormCommonService, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.presentLoad = false;
  }
  meetingAgendaList !: any;
  meetingResponse !: MeetingResponse;
  private meetingListSource = new BehaviorSubject<any>(this.meetingResponse);
  meetingListFromService = this.meetingListSource.asObservable();
  newAgList!: agendaList;

  collabMeetingObj = <MeetingCollabDetails>{};
  private collabMeetingDetails = new BehaviorSubject<MeetingCollabDetails>(this.collabMeetingObj);
  minuteCollabData = <MinutesCollabDetails>{};

  newMeetingVal!: MeetingResponse;
  newMeetingAgendaList!: any;
  presentLoad: boolean = false;

  convDetails = <speechToTextDetails>{};
  private newConvDetails = new BehaviorSubject<any>(this.convDetails);
  collabData!: MinutesCollabDetails;
  editCollabData = <MinutesCollabDetails>{};
  taskUpdateSource = new Subject<any>();
  taskRow$ = this.taskUpdateSource.asObservable();
  parentAgendaId!: any;
  agendaResp = new BehaviorSubject(this.newAgList);
  agendaRes = this.agendaResp.asObservable();
  meetingTime = new Subject<any>();
  meetTime$ = this.meetingTime.asObservable();
  curStatus = new Subject<any>();
  curStatus$ = this.curStatus.asObservable();
  ngAfterViewChecked() {
    //
  }
  observeMeetingResponse(): Observable<any> {
    return this.meetingListSource.asObservable();
  }

  observeConversation(): Observable<any> {
    return this.newConvDetails.asObservable();
  }
  observeCollabMeetingInfo(): Observable<any> {
    return this.collabMeetingDetails.asObservable();
  }


  getMeetingResponseFromListener(): any {
    return this.meetingListSource.getValue();
  }

  arryInsert = (arr: string | any[], index: any, newItem: any) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
  ]

  // const result = insert(items, 1, 10)
  joinOrLeaveSpeechToText(val: any) {
    this.newConvDetails.next(val);
  }

  setCollabData(val: any) {

    let oldMinList: any = [];
    let oldNote: any;
    let oldAgendaList: any[];

    if (this.meetingResponse.meetingId == val.meetingId) {
      if (val.collabType == "AgList") {
        if (val.element == "start") {
          document.getElementById('startTimer' + val.agendaId)!.innerHTML = "Stop";
          document.getElementById('clockIcon' + val.agendaId)?.click();
        }
        else if (val.element == "pause")
          document.getElementById('pauseTimer' + val.agendaId)?.click();
        else if (val.element == "resume")
          document.getElementById('playTimer' + val.agendaId)?.click();

      } else if (val.collabType == "MINEDIT") {
        if (this.meetingAgendaList != undefined) {

          if (this.meetingAgendaList[val.agElemPosition] != undefined) {
            oldMinList = this.meetingAgendaList[val.agElemPosition].minutesList;
            oldMinList.forEach((minElem: any, minIndex: any) => {
              if ((minElem.noteId != null && minElem.noteId == val.elementId) || (minElem.decisionId != null && minElem.decisionId == val.elementId) || (minElem.taskId != null && minElem.taskId == val.elementId)) {
                this.meetingAgendaList[val.agElemPosition].minutesList[minIndex].rowStatus = val.sentByUserName + " is Typing";
              }
            });
          }
        }
      }
      else if (val.collabType == "MIN") {
        const modifiedNote = val.elementVal;
        if (val.agElemPosition != undefined && val.minElemPosition != undefined) {

          if (this.meetingAgendaList != undefined) {
            oldMinList = this.meetingAgendaList[val.agElemPosition].minutesList;

            oldNote = oldMinList[val.minElemPosition];
            if (oldNote != undefined && oldNote._id == modifiedNote._id) {
              if (modifiedNote.isPrivate == "Y") {

                const newMinList: any = [];
                if (oldMinList != null && oldMinList != undefined) {
                  oldMinList.forEach((minElem: any, minIndex: any) => {
                    newMinList.push(minElem);

                    if ((minElem.noteId != null && minElem.noteId == val.elementId) || (minElem.decisionId != null && minElem.decisionId == val.elementId) || (minElem.taskId != null && minElem.taskId == val.elementId)) {

                      newMinList.pop();
                    }
                  });
                  this.meetingAgendaList[val.agElemPosition].minutesList = newMinList;
                  this.meetingResponse.agendaList = this.meetingAgendaList;
                }

              }
              else {
                //oldMinList[val.minElemPosition].noteDescription=modifiedNote.noteDescription

                oldMinList[val.minElemPosition].rowStatus = "";
                oldMinList[val.minElemPosition] = modifiedNote;
                this.meetingAgendaList[val.agElemPosition].minutesList = oldMinList;
                this.meetingResponse.agendaList = this.meetingAgendaList;
              }

            } else {
              var existsFlag = false;
              if (oldMinList != null && oldMinList != undefined) {
                oldMinList.forEach((minElem: any, minIndex: any) => {
                  if ((minElem.noteId != null && minElem.noteId == val.elementId) || (minElem.decisionId != null && minElem.decisionId == val.elementId) || (minElem.taskId != null && minElem.taskId == val.elementId)) {
                    existsFlag = true;
                  }
                });
              }
              if (existsFlag == false) {

                const insertingNote = modifiedNote;
                if (insertingNote.isPrivate != "Y") {
                  oldMinList = this.arryInsert(oldMinList, val.minElemPosition, modifiedNote);
                }
              }
              this.meetingAgendaList[val.agElemPosition].minutesList = oldMinList;
              this.meetingResponse.agendaList = this.meetingAgendaList;
            }

          }

          var minutesService = this.injector.get(FreeFormMinutesService);
          for (var i in CKEDITOR.instances) {
            //var name = CKEDITOR.instances[i].name;
            var prom = new Promise<string>((resolve, reject) => {
              if (CKEDITOR.instances[i].name == "agMinId" + modifiedNote.minutesId) {
                CKEDITOR.instances[i].destroy(true);
                var itrl = setInterval(() => {
                  if (CKEDITOR.instances["agMinId" + modifiedNote.minutesId] == undefined) {
                    clearInterval(itrl);
                    resolve("agMinId" + modifiedNote.minutesId);
                  }
                }, 1000);

              }
            }).then((ckId) => {
              let element = (<HTMLElement>document.getElementById(ckId))
              element.contentEditable = 'true'
              var divContent = document.getElementById(ckId);
              minutesService.activateCkeditor(divContent);
            }).finally(() => {
            });
          }


        }

      } else if (val.collabType == "MINATTACH") {
        if (val.agElemPosition != undefined && val.minElemPosition != undefined) {
          if (val.elementVal.isFollowUpFlag == "Y") {
            this.meetingAgendaList[val.agElemPosition].minutesList[val.minElemPosition].followUpTaskInfo.attachmentTotalCnt = val.attachmentTotalCnt;
          } else {
            this.meetingAgendaList[val.agElemPosition].minutesList[val.minElemPosition].attachmentTotalCnt = val.attachmentTotalCnt;
          }
          this.meetingResponse.agendaList = this.meetingAgendaList
        }

      }
      else if (val.collabType == "AG") {
        if (this.meetingAgendaList != undefined) {
          const oldAgenda = this.meetingAgendaList[val.agElemPosition];

          oldAgendaList = this.meetingAgendaList;
          const modifiedAgenda = val.elementVal;

          if (oldAgenda != undefined && oldAgenda.agendaId == modifiedAgenda.agendaId) {
            //
            const mintList = oldAgenda.minutesList;
            oldAgendaList[val.agElemPosition] = modifiedAgenda;
            oldAgendaList[val.agElemPosition].minutesList = mintList;
            //oldAgendaList[val.agElemPosition].agendaTitle=modifiedAgenda.agendaTitle;
          } else {

            oldAgendaList = this.arryInsert(oldAgendaList, val.agElemPosition, val.elementVal);
          }
          this.meetingAgendaList = oldAgendaList;
        }
        this.meetingResponse.agendaList = this.meetingAgendaList;
      } else if (val.collabType == "AGATTACH") {
        if (this.meetingAgendaList != undefined) {
          const oldAgenda = this.meetingAgendaList[val.agElemPosition];
          oldAgendaList = this.meetingAgendaList;
          if (oldAgenda != undefined && oldAgenda.agendaId == val.elementId) {
            oldAgendaList[val.agElemPosition].attachmentTotalCnt = val.attachmentTotalCnt;
          }
          this.meetingAgendaList = oldAgendaList;
          this.meetingResponse.agendaList = this.meetingAgendaList;
        }

      }
      else if (val.collabType == "MEETING") {

        //this.meetingResponse[val.fieldName]=val.fieldValue;
        this.collabMeetingDetails.next(val);

      }
      else if (val.collabType == "MEETINGDATEANDTIME") {

        this.collabMeetingDetails.next(val);
      }
      else if (val.collabType == "JOINMEETING" || val.collabType == "EXITMEETING") {
        if (this.meetingResponse.attendeeList != undefined) {
          if (this.meetingResponse.meetingEndFlag !== "Y" && this.meetingResponse.meetingStartFlag == "Y") {
            let sucMes = "";
            this.meetingResponse.attendeeList.forEach((partObj: any, partIndex: any) => {
              if (partObj.fkSecUserAttendee == val.elementId) {
                if (val.collabType == "JOINMEETING") {
                  partObj.isJoined = "Y";
                  sucMes = val.sentByUserName + " has joined";
                } else {
                  partObj.isJoined = "N";
                  sucMes = val.sentByUserName + " has left";
                }
              }
            });
            this.notifier.show({
              type: 'success',
              message: sucMes
            });
          }
        }
      }
      else if (val.collabType == "RECORDMEETING") {
        let sucMes = "";
        sucMes = environment_msg.msg_notify_recording_for_others.replace("{sentByUserName}", val.sentByUserName);
        this.notifier.show({
          type: 'success',
          message: sucMes
        });
      } else if (val.collabType == "ATTENDEE") {
        if (this.meetingResponse.attendeeList != undefined) {
          if (val.actionType == 'A') {
            this.meetingResponse.attendeeList?.push(val.elementVal);
          }
          else if (val.actionType == "D") {

            let index = -1;
            this.meetingResponse.attendeeList.forEach((partObj: any, partIndex: any) => {
              if (partObj.attendeeId == val.elementId) {
                index = partIndex;
              }
            });
            if (index !== -1 && index != null) {
              this.meetingResponse.attendeeList?.splice(index, 1);
            }
          }
        }
      } else if (val.collabType == "MINDELETE" || val.collabType == "MINPRIVATE") {

        this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
          const newMinList: any = [];
          if (agElem.agendaId == val.agElementId) {
            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {
                newMinList.push(minElem);
                if ((minElem.noteId != null && minElem.noteId == val.elementId) || (minElem.decisionId != null && minElem.decisionId == val.elementId) || (minElem.taskId != null && minElem.taskId == val.elementId)) {
                  newMinList.pop();
                }
              });
              this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there 
            }
          }
        });
        this.meetingResponse.agendaList = this.meetingAgendaList;
      }
      else if (val.collabType == "ENDMEETING" || val.collabType == "STARTMEETING") {


        this.collabMeetingDetails.next(val);
      }
      setTimeout(() => {
        this.flattenedDTOs = this.meetingResponse.agendaList;
        this.rebuildHierarchy();
      }, 500)

    }
  }

  setMeetingResponseFromListener(val: any) {

    var newAgList: any = [];
    var newMinList: any = [];
    var oldMinList: any = [];
    var oldAgendaList: any[];
    var oldNote: any;
    if (val.elementType == "MEETING") {

      this.meetingResponse.meetingTitle = val.meetingTitle;
      this.meetingResponse.meetingDateShortFormat = val.meetingDateShortFormat;
      this.meetingResponse.meetingStartTime = val.meetingStartTime;
      this.meetingResponse.duration = val.duration;
      this.meetingResponse.meetingDateStr = val.meetingDateStr;
      this.meetingResponse.meetingDateFullFormat = val.meetingDateFullFormat;
      this.meetingResponse.attendeeList = val.attendeeList;
      val = this.meetingResponse;
      this.meetingListSource.next(val);
    } else if (val.elementType == "MIN" || val.elementType == "MINATTACH") {
      if (val.agendaList[val.agElemPosition] != undefined && val.agendaList[val.agElemPosition].minutesList[val.minElemPosition] != undefined) {
        var modifiedNote = val.agendaList[val.agElemPosition].minutesList[val.minElemPosition];
        if (this.meetingAgendaList != undefined) {
          oldMinList = this.meetingAgendaList[val.agElemPosition].minutesList;
          oldNote = oldMinList[val.minElemPosition];
          if (oldNote != undefined && oldNote._id == modifiedNote._id) {
            oldMinList[val.minElemPosition] = modifiedNote;
            //oldMinList[val.minElemPosition].noteDescription=modifiedNote.noteDescription;
          }
          this.meetingAgendaList[val.agElemPosition].minutesList = oldMinList;
        }
        oldMinList = this.meetingAgendaList[val.agElemPosition].minutesList;
        val.agendaList[val.agElemPosition].minutesList.forEach((minElem: any, minIndex: any) => {
          var oldElem = this.meetingAgendaList[val.agElemPosition].minutesList[minIndex];
          var existsFlag = false;
          if (oldElem == undefined || oldElem._id != minElem._id) {
            oldMinList.forEach((olMinElem: any, oldMinIndex: any) => {
              if (minElem._id == olMinElem._id) {
                existsFlag = true;
              }
            });
            if (existsFlag == false) {
              var insertingNote = val.agendaList[val.agElemPosition].minutesList[minIndex];

              if (insertingNote.isPrivate == "N" || (insertingNote.createdBy == localStorage.userId)) {
                oldMinList = this.arryInsert(oldMinList, minIndex, val.agendaList[val.agElemPosition].minutesList[minIndex]);
              }
            }
          }
        });
        this.meetingAgendaList[val.agElemPosition].minutesList = oldMinList;
      }
      val.agendaList = this.meetingAgendaList;
      this.meetingResponse.agendaList = val.agendaList;
      this.meetingResponse.attendeeList = val.attendeeList;
      this.meetingListSource.next(val);
    }
    else if (val.elementType == "AG" || val.elementType == "AGATTACH") {

      if (this.meetingAgendaList != undefined) {
        var oldAgenda = this.meetingAgendaList[val.agElemPosition];
        oldAgendaList = this.meetingAgendaList;


        var modifiedAgenda = val.agendaList[val.agElemPosition];

        if (oldAgenda != undefined && oldAgenda.agendaId == modifiedAgenda.agendaId) {
          //
          oldAgendaList[val.agElemPosition] = modifiedAgenda;
          //oldAgendaList[val.agElemPosition].agendaTitle=modifiedAgenda.agendaTitle;
        }
        oldAgendaList = this.meetingAgendaList;

        val.agendaList.forEach((agElem: any, newIndex: any) => {

          var oldAgElem = this.meetingAgendaList[newIndex];
          var existsFlag = false;

          if (oldAgElem == undefined || oldAgElem.agendaId != agElem.agendaId) {

            this.meetingAgendaList.forEach((oldAgElem: any, oldAgIndex: any) => {
              if (oldAgElem.agendaId == agElem.agendaId) {
                existsFlag = true;
              }
            });

            if (existsFlag == false) {
              oldAgendaList = this.arryInsert(oldAgendaList, newIndex, val.agendaList[newIndex]);
            }
          }
        });

        this.meetingAgendaList = oldAgendaList;
      }
      val.agendaList = this.meetingAgendaList;
      this.meetingResponse.agendaList = val.agendaList;
      this.meetingResponse.attendeeList = val.attendeeList;
      this.meetingListSource.next(val);
    }
    else if (val.elementType == "MINEDIT") {
      //
      if (val.agendaList[val.agElemPosition] != undefined && val.agendaList[val.agElemPosition].minutesList[val.minElemPosition] != undefined) {
        var modifiedNote = val.agendaList[val.agElemPosition].minutesList[val.minElemPosition];
        modifiedNote.rowStatus = val.sentByUserName + " is Typing";
        if (this.meetingAgendaList != undefined && this.meetingAgendaList[val.agElemPosition] != undefined) {
          oldMinList = this.meetingAgendaList[val.agElemPosition].minutesList;
          oldNote = oldMinList[val.minElemPosition];

          if (oldNote != undefined && oldNote._id == modifiedNote._id) {
            oldMinList[val.minElemPosition] = modifiedNote;
          }
          this.meetingAgendaList[val.agElemPosition].minutesList = oldMinList;
        }

        val.agendaList = this.meetingAgendaList;
        this.meetingResponse.agendaList = val.agendaList;

      }
      this.meetingResponse.attendeeList = val.attendeeList;
      this.meetingListSource.next(val);
    } else if (val.elementType == "MINDELETE" || val.elementType == "MINPRIVATE") {

      this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
        var newMinList: any = [];
        if (agElem.agendaId == val.agElementId) {
          if (agElem.minutesList != null && agElem.minutesList != undefined) {
            agElem.minutesList.forEach((minElem: any, minIndex: any) => {
              newMinList.push(minElem);
              if ((minElem.noteId != null && minElem.noteId == val.elementId) || (minElem.decisionId != null && minElem.decisionId == val.elementId) || (minElem.taskId != null && minElem.taskId == val.elementId)) {
                newMinList.pop();
              }
            });
            this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there 
          }
        }
      });
      val.agendaList = this.meetingAgendaList;
      this.meetingResponse.agendaList = val.agendaList;
      this.meetingResponse.attendeeList = val.attendeeList;
      this.meetingListSource.next(val);
    } else if (val.elementType == "JOINMEETING" || val.elementType == "EXITMEETING") {

      var reqJson = "";
      var sucMes = val.sentByUserName + " has joined";
      if (val.elementType == "JOINMEETING") {
        this.notifier.show({
          type: 'success',
          message: sucMes
        });
      }
      if (val.elementType == "EXITMEETING") {
        sucMes = val.sentByUserName + " has left";
        this.notifier.show({
          type: 'success',
          message: sucMes
        });
      }
      val.elementType = "";
      this.webTranService.getUserLoggedInStatus(val.meetingId, reqJson).subscribe((data) => {

        if (data.body != null) {
          let attendeestatuslst = JSON.parse(data.body);
          val.attendeeList.forEach((partObj: any, partIndex: any) => {
            attendeestatuslst.forEach((attObjElem: any, attIndex: any) => {
              let attVal = JSON.parse(attObjElem);
              if (partObj.fkSecUserAttendee == attVal.userId) {

                if (attVal.loggedStatus == "LOGIN") {
                  val.attendeeList[partIndex].isJoined = "Y";
                } else if (attVal.loggedStatus == "LOGOUT") {
                  val.attendeeList[partIndex].isJoined = "N";
                }
              }
            });
          });
        }
      });
      this.meetingResponse.attendeeList = val.attendeeList;
      //val.agendaList= this.meetingAgendaList;
      this.meetingListSource.next(this.meetingResponse);
    } else if (val.elementType == "ENDMEETING" || val.elementType == "STARTMEETING") {


      this.meetingListSource.next(val);
    }


  }


  //Method to capture agenda enter event
  trackAgendaEvent(event: any) {
    var obj = event.currentTarget as HTMLElement;
    var pageIns = this;
    var duration = (event.altKey && event.keyCode == 82)
    if (event.which == 13 || duration) {
      var sel = window.getSelection && window.getSelection();
      var position = 0;
      var actualText = obj.innerText;
      var actualHtml = obj.innerHTML;
      var curAgendaId = obj.getAttribute("agid");
      var croppedText = "";
      var matchString = "";
      var additionalJson: any = {};
      var lastIndexOfChar = -1;
      var isPreNote = "";
      if (sel && sel.rangeCount > 0) {
        var range = window.getSelection()?.getRangeAt(0);
        position = this.utilService.getCharacterOffsetWithin(range, obj);
      }
      croppedText = actualText.substring(0, position);
      lastIndexOfChar = croppedText.lastIndexOf("/");
      matchString = actualText.substring(lastIndexOfChar, position);
      additionalJson.start = lastIndexOfChar;
      additionalJson.end = position;
      this.parentAgendaId = "";
      if (matchString != "" && matchString != undefined && (matchString == this.globals.agendaSubCode) && this.globals.addAgendaGlobalRights) {
        this.parentAgendaId = curAgendaId
        matchString = "/ag";
      }
      if (matchString != "" && matchString != undefined && (matchString == this.globals.agendaSubAtLastCode) && this.globals.addAgendaGlobalRights) {
        this.parentAgendaId = curAgendaId
        matchString = "/agl";
      }

      if (matchString != "" && matchString != undefined && (matchString == this.globals.agendaCode || matchString == this.globals.agendaAtLastCode) && this.globals.addAgendaGlobalRights) {

        this.createEmptyAgenda('Y').then((empAgendaDetail: any) => {
          if (empAgendaDetail != null && empAgendaDetail != "" && empAgendaDetail != undefined) {

            if (matchString == this.globals.agendaCode) {
              this.utilService.replaceShortcut(additionalJson, obj, this.globals.agendaRegexCode);
            } else {
              this.utilService.replaceShortcut(additionalJson, obj, this.globals.agendaAtLastRegexCode);
              empAgendaDetail.insertAtLast = "Y";
            }
            this.pushAgendaConstruction(empAgendaDetail, obj).then((result: any) => {
              setTimeout(function () {
                var empAgendaId = empAgendaDetail.agendaId;
                $("#meetAgendaId" + empAgendaId).focus();
                //pageIns.updateAgenda($("#meetAgendaId" + curAgendaId), null,'N');
              }, 500);
            });

          }
        });
        event.preventDefault();
        return false;
      } else if (matchString != "" && matchString != undefined && (matchString == this.globals.agDurationCode) && this.globals.editAgendaGlobalRights) {
        if (!duration) {
          this.utilService.replaceShortcut(additionalJson, obj, this.globals.agDurationRegexCode);
        }
        this.checkAgendaDurationExceed(this.globals.defaultAgendaDuration, curAgendaId).then((resp: any) => {
          if ($(obj).find(".agDurCls").length == 0) {
            var durHtml = '<span contenteditable="false" class="agDurCls"><span class="agDurLabelCls">[ </span>' + this.globals.defaultAgendaDuration + '<span class="agDurLabelCls"> Minutes ]</span></span>';
            var conf = true;

            this.meetingService.changeMessage(this.meetingResponse.duration);
            if ($(obj).children().last().prop("tagName") == "DIV") {
              $(obj).children().last().remove();
            }
            if (conf) {

              $(obj).append(durHtml);
              this.pushAgendaDuration(curAgendaId, this.globals.defaultAgendaDuration);
              //$("#agendaMainId" + curAgendaId).attr("agendatime", this.globals.defaultAgendaDuration);
            }
          }
          this.utilService.placeCaretAtEnd($(obj)[0]);
          event.preventDefault();
          return false;
        });
      } else if (matchString != "" && matchString != undefined && ((matchString == this.globals.noteCode) || (matchString == this.globals.noteAtLastCode)) && this.globals.addNoteGlobalRights) {
        if (matchString == this.globals.noteCode) {
          additionalJson.replaceText = this.globals.noteRegexCode;
        } else if (matchString == this.globals.noteAtLastCode) {
          additionalJson.replaceText = this.globals.noteAtLastRegexCode;
          additionalJson.insertAtLast = "Y";
        }

        this.midMinutesConstruction(event, environment.noteEntityType, obj, additionalJson);
      } else if (matchString != "" && matchString != undefined && ((matchString == this.globals.decisionCode) || (matchString == this.globals.decisionAtLastCode)) && this.globals.addNoteGlobalRights) {
        if (matchString == this.globals.decisionCode) {
          additionalJson.replaceText = this.globals.decisionRegexCode;
        } else if (matchString == this.globals.decisionAtLastCode) {
          additionalJson.replaceText = this.globals.decisionAtLastRegexCode;
          additionalJson.insertAtLast = "Y";
        }
        this.midMinutesConstruction(event, environment.decisionEntityType, obj, additionalJson);
      } else if (matchString != "" && matchString != undefined && ((matchString == this.globals.taskCode) || (matchString == this.globals.taskAtLastCode)) && this.globals.addTaskGlobalRights) {
        if (matchString == this.globals.taskCode) {
          additionalJson.replaceText = this.globals.taskRegexCode;
        } else if (matchString == this.globals.taskAtLastCode) {
          additionalJson.replaceText = this.globals.taskAtLastRegexCode;
          additionalJson.insertAtLast = "Y";
        }
        this.midMinutesConstruction(event, environment.taskEntityType, obj, additionalJson);
      } else {
        event.preventDefault();
        return false;
      }
    }
    if (event.shiftKey && event.which == 50) {
      this.loadTaskAssigneeAndAgPresenter(true, "AG", obj);
    }
    return true;
  }


  //Method used to construct minutes
  midMinutesConstruction(event: any, entityTypeCode: any, obj: HTMLElement, additionalJson: any) {
    this.editCollabData = <MinutesCollabDetails>{};
    return Promise.resolve((() => {



      var isPreviews = "";
      var jsonData: any = {};
      var replaceTxt = "";
      var insertAtLast = "N";
      var elem;
      var createNewNote = "";
      var convertMinutes = "";
      var pageIns = this;
      if (additionalJson.replaceText != null && additionalJson.replaceText != "" && additionalJson.replaceText != undefined) {
        replaceTxt = additionalJson.replaceText;
      }
      if (additionalJson.insertAtLast != null && additionalJson.insertAtLast != "" && additionalJson.insertAtLast != undefined) {
        jsonData.insertAtLast = additionalJson.insertAtLast;
      }
      if (additionalJson.isDefaultNotes != null && additionalJson.isDefaultNotes != "" && additionalJson.isDefaultNotes != undefined) {
        jsonData.isDefaultNotes = additionalJson.isDefaultNotes;
      }
      if (additionalJson.isCopied != null && additionalJson.isCopied != "" && additionalJson.isCopied != undefined) {
        jsonData.isCopied = additionalJson.isCopied;
      }
      if (additionalJson.noteDescription != null && additionalJson.noteDescription != "" && additionalJson.noteDescription != undefined) {
        jsonData.noteDescription = additionalJson.noteDescription;
      }
      if (additionalJson.prevnoteType != null && additionalJson.prevnoteType != "" && additionalJson.prevnoteType != undefined) {
        jsonData.prevnoteType = additionalJson.prevnoteType;
      }


      if ((this.meetingResponse.meetingStartFlag != "Y") && (isPreviews == "" || isPreviews == "Y")) {
        isPreviews = "Y";
        jsonData.isPreviews = isPreviews;


      } else {
        isPreviews = "N";
        jsonData.isPreviews = isPreviews;


      }
      this.utilService.replaceShortcut(additionalJson, obj, replaceTxt);
      var agId = obj.getAttribute("agId");
      if (this.utilService.nvl(obj.getAttribute("isFollowUpFlag")) == "Y") {
        agId = obj.getAttribute("curAgendaId");
      }


      if (agId != null && agId != "" && agId != undefined) {


        jsonData.agendaId = agId;
        if (jsonData != null && jsonData != undefined) {

          this.createEmptyMinutes(jsonData, entityTypeCode, obj, convertMinutes).then((resultData: any) => {
            if (resultData != null && resultData.minutesId != null && resultData.minutesId != "" && resultData.minutesId != undefined) {

              var minId = resultData.minutesId;
              this.pushMinutesConstruction(resultData, obj).then((result: any) => {
                var minId = resultData.minutesId;

                setTimeout(function () {
                  $("#agMinId" + minId).focus();
                  pageIns.updateModernMinutesSeq($("#agMinId" + minId));
                  pageIns.callPushMessageToServer(pageIns.meetingResponse, obj, 'MIN');
                  setTimeout(function () {
                    $("#agMinId" + minId).focus();
                    pageIns.utilService.placeCaretAtEnd($("#agMinId" + minId)[0]);
                  }, 500);
                }, 5);
              });
              pageIns.meetingAgendaList.forEach((agElem: any, agIndex: any) => {

                if (agElem.agendaId == resultData.agendaId) {
                  pageIns.editCollabData.agElemPosition = agIndex;

                  if (agElem.minutesList != null && agElem.minutesList != undefined) {
                    agElem.minutesList.forEach((minElem: any, minIndex: any) => {

                      if ((minElem.noteId != null && minElem.noteId == resultData.minutesId) || (minElem.decisionId != null && minElem.decisionId == resultData.minutesId) || (minElem.taskId != null && minElem.taskId == resultData.minutesId)) {
                        pageIns.editCollabData.minElemPosition = minIndex;
                      }
                    });
                  }
                }
              });
              pageIns.editCollabData.elementVal = resultData;
              pageIns.editCollabData.collabType = 'MIN';
              pageIns.editCollabData.elementId = resultData.minutesId;
              pageIns.editCollabData.meetingId = pageIns.meetingResponse.meetingId;
              pageIns.callPushMessageToServer(pageIns.editCollabData, obj, 'MIN');
            }
          });
        }
      }
      if (event != undefined && event != null && typeof event.cancel === 'function') {
        event.cancel();
      } else if (event != undefined && event != null && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      //
      return true;
    })());
  }

  public callPushMessageToServer(respObj: any, element: any, elemType: any) {
    this.webTranService.pushMesssageToProducer(respObj.meetingId, respObj).subscribe((data) => {

    });
  }

  public pushPrivateMinutes(minDetails: any, respObj: any) {

    this.minuteCollabData = <MinutesCollabDetails>{};
    let selMinId: any;
    selMinId = respObj.minutesId;
    this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
      if (agElem.agendaId == minDetails.agendaId) {
        this.minuteCollabData.agElemPosition = agIndex;
        this.minuteCollabData.agElementId = minDetails.agendaId;
        if (agElem.minutesList != null && agElem.minutesList != undefined) {
          agElem.minutesList.forEach((minElem: any, minIndex: any) => {
            if ((minElem.noteId != null && minElem.noteId == selMinId) || (minElem.decisionId != null && minElem.decisionId == selMinId) || (minElem.taskId != null && minElem.taskId == selMinId)) {
              this.minuteCollabData.minElemPosition = minIndex;
              this.minuteCollabData.elementVal = minElem;
            } else {
              minElem.rowStatus = "";
            }
          });

        }
      }
    });
    this.minuteCollabData.collabType = 'MINPRIVATE';
    this.minuteCollabData.elementId = selMinId;
    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      this.minuteCollabData.meetTypeVal = this.meetingResponse.meetingType;
    }

    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.minuteCollabData).subscribe((data) => {

    });
  }

  public shareDatatoService(dataFromComp: MeetingResponse) {
    this.meetingResponse = dataFromComp;

    this.meetingAgendaList = dataFromComp.agendaList;

    //this.meetingAgendaListSource.next(dataFromComp);
  }


  //Method to create empty agenda
  createEmptyAgenda(isEmptyAgenda: any) {
    return new Promise((resolve, reject) => {
      var agendaTitle = "<br/>";//to create empty agenda
      if (isEmptyAgenda != "Y") {
        agendaTitle = environment.defAgendaTitle;//to create default agenda
      }
      var resultJson = {};
      var agendajsonobj: any = {
        "meetingId": this.meetingResponse.meetingId,
        "agendaTitle": agendaTitle,
        // "agendaOwner": "",
        "agendaTime": "",
        //	"durationmints":$(".mtngdur").val(),
        "agendaId": "",
        // "fkSecuserOwner": "",
        // "agendaNoteDesc": "",
        //"agendaStartTime":$("#meetingTime").val(),
        // "agendaEndTime": "0",
        // "remainAgendaTime": "",
        "agendaseconds": 0,
        // "agendaRemainingTimer": 0,
        "agendaCompleteFlag": "N",
        "agendaEndFlag": "N",
        "defaultNotes": ""
      };
      if (this.parentAgendaId != null && this.parentAgendaId != undefined && this.parentAgendaId != "")
        agendajsonobj["parentAgendaId"] = this.parentAgendaId;
      var agendajsonString = JSON.stringify(agendajsonobj);
      //to create only empty agenda
      this.meetingService.saveModernAgenda(agendajsonString).subscribe(res => {
        var resp = res.body;
        resp.agendaTitle = agendajsonobj.agendaTitle;
        //
        resolve(resp);
      });
    });
  }
  createEmptyAgendaFromMinutes(isEmptyAgenda: any, parentAgendaId: any) {
    return new Promise((resolve, reject) => {
      var agendaTitle = "<br/>";//to create empty agenda
      if (isEmptyAgenda != "Y") {
        agendaTitle = environment.defAgendaTitle;//to create default agenda
      }
      var resultJson = {};
      var agendajsonobj: any = {
        "meetingId": this.meetingResponse.meetingId,
        "agendaTitle": agendaTitle,
        "agendaTime": "",
        "agendaId": "",
        "agendaseconds": 0,
        "agendaCompleteFlag": "N",
        "agendaEndFlag": "N",
        "defaultNotes": "",
      };
      if (parentAgendaId != null && parentAgendaId != undefined && parentAgendaId != "")
        agendajsonobj["parentAgendaId"] = parentAgendaId;
      var agendajsonString = JSON.stringify(agendajsonobj);
      //to create only empty agenda
      this.meetingService.saveModernAgenda(agendajsonString).subscribe(res => {
        var resp = res.body;
        resp.agendaTitle = agendajsonobj.agendaTitle;
        resolve(resp);
      });
    });
  }


  callOnBlur(event: any, isGuestAgendaPresenter: any, calledFrom: any) {
    var pageIns = this;
    var obj: HTMLElement = event.target;
    var agendaId = $(obj).attr("agid");
    var durPopElement = document.getElementById("agPopover" + agendaId);
    var agDurPopOverDisplay = $(durPopElement).css("display");
    if (agDurPopOverDisplay != 'block' && !this.presentLoad) {
      pageIns.updateAgenda(obj, isGuestAgendaPresenter, "B");
    }
    this.presentLoad = false;
  }

  //Method to update agenda
  updateAgenda(obj: any, isGuestAgendaPresenter: any, calledFrom: any) {
    var agendaId = $(obj).attr("agid");
    //var agendaTraceId = Number($(obj).attr("agendaTraceId"));
    var agendaTraceId: number;
    var agendaTimerFlag: any;
    agendaTraceId = $(obj).attr("agendaTraceId");
    agendaTimerFlag = $(obj).attr("agendaTimerFlag");
    var agendaTimerInSeconds = document.querySelector('#clock' + agendaId)?.innerHTML;
    var agendaTitle = "";
    var agendaPresenterName = "";
    var agendaPresenterId = "";
    var agList: any = [];
    var newMinList: any = [];
    var pageIns = this;
    var agSeqMap: any = new Object();
    var agendaJSONReq: any;
    agendaTitle = this.commonService.trimNoteDesc(obj, 'AG', '');
    this.removeLastCommaFromConstruct(obj);//to remove last comma from agendapresenter

    var agendaTime = this.commonService.trimAgendaDuration($("#meetAgendaId" + agendaId)[0]);
    this.meetingAgendaList.forEach((element: { agendaId: any; parentAgendaId: any; }) => {
      if (element.agendaId == agendaId) {
        this.parentAgendaId = element.parentAgendaId;
      }
    });

    if (agendaId != null && agendaId != "" && agendaId != undefined) {
      var agendajsonobj: any = {
        "agendaTitle": agendaTitle.trim(),
        "agendaPresenterList": this.commonService.trimAgPresenterList(obj),
        "agendaDuration": agendaTime,
        "agendaId": parseInt(agendaId),
        "meetingId": this.meetingResponse.meetingId,
        "userId": this.globals.userId,
        "agendaTimer": agendaTimerInSeconds,
        "agendaTraceId": agendaTraceId,
        "agendaFlag": agendaTimerFlag

      };

      if (this.parentAgendaId != null && this.parentAgendaId != undefined && this.parentAgendaId != "") {
        agendajsonobj["parentAgendaId"] = this.parentAgendaId;
      }
      var agendajsonString = JSON.stringify(agendajsonobj);
      this.meetingService.updateModernAgenda(agendajsonString, agendaId).subscribe(res => {
        this.editCollabData = <MinutesCollabDetails>{};
        var resp = res.body;
        this.editCollabData.elementId = agendaId;
        this.editCollabData.collabType = 'AG';
        this.editCollabData.meetingId = this.meetingResponse.meetingId;
        var prevAgendaId = $(obj).attr("agid");
        this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
          var seq = 0;
          if (agElem.agendaId == prevAgendaId) {
            this.editCollabData.agElemPosition = agIndex;
            // This one commented to save other users content properly
            // this.editCollabData.elementVal = resp;
            newMinList = agElem.minutesList;
            resp.minutesList = newMinList;
            //resp.agendaTimerInSeconds = agElem.agendaTimerInSeconds;
            agList.push(resp);
            this.meetingResponse.agElemPosition = agIndex;
          } else {
            agList.push(agElem);
          }
          if (pageIns.utilService.nvl(agElem.agendaId) != "") {
            seq = agIndex + 1;
            agSeqMap[Number(seq)] = Number(agElem.agendaId);
          }
          var agSeqList = JSON.stringify(agSeqMap);
          agendaJSONReq = { "meetingId": this.meetingResponse.meetingId, "agSeqList": agSeqList };
        });
        this.meetingService.updateAgendaSequence(JSON.stringify(agendaJSONReq)).subscribe(res => {
        });
        //this.meetingAgendaList = agList;
        //this.meetingResponse.agendaList = this.meetingAgendaList;
        var newMeetResp = this.meetingResponse;
        newMeetResp.agendaList = agList;
        if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
          this.editCollabData.meetTypeVal = this.meetingResponse.meetingType;
        }

        this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.editCollabData).subscribe((data) => {
          this.meetingAgendaList = agList;

          if (calledFrom == "B") {
            var minutesService = this.injector.get(FreeFormMinutesService);
            minutesService.destroyCkInstane('minComCls');
            minutesService.activateAllCkeditor('minComCls');
          }
        });

      });
    }
  }

  //to append agenda
  pushAgendaConstruction(jsonData: any, obj: HTMLElement) {
    return new Promise((resolve, reject) => {
      var agList: any = [];
      if (jsonData.insertAtLast != null && jsonData.insertAtLast != "" && jsonData.insertAtLast != undefined && jsonData.insertAtLast == "Y") {
        this.meetingAgendaList.push(jsonData);
        this.meetingResponse.agendaList = this.meetingAgendaList;
        this.agendaResp.next(this.meetingAgendaList);
      } else {
        var prevAgendaId = obj.getAttribute("agid");
        if (this.utilService.nvl(obj.getAttribute("isFollowUpFlag")) == "Y") {
          prevAgendaId = obj.getAttribute("curAgendaId");
        }
        this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
          agList.push(agElem);
          if (agElem.agendaId == prevAgendaId) {
            agList.push(jsonData);
          }
        });
        this.meetingAgendaList = agList;
        this.meetingResponse.agendaList = this.meetingAgendaList;
        this.agendaResp.next(agList);
      }
      resolve(this.meetingAgendaList);
    });
  }


  //to pop agenda list
  popAgendaList(agendaId: any) {
    var agList: any = [];
    this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
      agList.push(agElem);
      if (agElem.agendaId == agendaId) {
        agList.pop();
      }
    });
    this.meetingAgendaList = agList;
    this.meetingResponse.agendaList = this.meetingAgendaList;
    this.agendaResp.next(agList);
    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.meetingResponse).subscribe((data) => {
      //
    });
    this.updateAgendaSequence();
  }



  //Method to update action Item for each keypress 
  updateActionItem(obj: HTMLElement, additionalJsonObj: any) {

    var data: any = {};
    var updatedResult: any = {};
    var actionItemId = obj.getAttribute("minid");
    var entityId = obj.getAttribute("agid");
    var meetingId: any = this.meetingResponse.meetingId;//this.meetingId;//$("#meetingId").val();
    if (actionItemId != null && actionItemId != "" && actionItemId != undefined && actionItemId != "undefined" && entityId != null && entityId != undefined) {
      var curTaskStatus: any = "";
      curTaskStatus = additionalJsonObj.status
      if (curTaskStatus == null || curTaskStatus == "" || curTaskStatus == undefined || curTaskStatus == "undefined" || curTaskStatus == "null") {
        curTaskStatus = environment.pendingStatus;
      }
      if (obj.getAttribute("isFollowUpFlag") == "Y") { // if the minutes belongs to followup then here we are overriding min, agenda,and meeting Id
        //   entityId = obj.getAttribute("prevAgendaId");
        meetingId = obj.getAttribute("meetingId");
        //actionItemId = obj.getAttribute("prevMinuteId");
      }
      data.agendaId = entityId;
      var jsonObj: any = {};
      if (this.meetingResponse.isConfidential == "Y") {
        jsonObj = {
          "assignedToUpdate": this.commonService.trimAssignedToAI(obj),
          "assignedTo": this.commonService.trimAssignedToList(obj, curTaskStatus),
          "taskStatus": curTaskStatus,
          "dueDateStr": this.commonService.trimActionItemDueDate(obj),
          //"notes": "",
          "meetingId": meetingId,
          "minutesId": actionItemId?.replace("T_", ""),
          //"actionItemId": actionItemId,
          // "meetingTitle": $("#topMeetTitle").text(),
          "taskTitle": this.commonService.trimNoteDesc(obj, environment.taskEntityType, ""),
          "agendaId": entityId,
          "guestOwnerName": this.commonService.guestAssignedToAI(obj),
          //"isPrivate": obj.getAttribute("isPrivate") != undefined ? obj.getAttribute("isPrivate") : "N",
          "noteTypeId": this.globals.comNoteTypeId,
          "noteTypeCode": this.globals.comNoteTypeCode,
          "taskId": obj.getAttribute("taskId"),
          "taskEditFrom": "MT",
          "visitorTimeZone": this.globals.vTimeZone,
          "userId": this.globals.userId,
          "deletedFlag": 0,
          "encryptKey": localStorage.getItem("savedpasswords" + "_" + meetingId),
        };
      }
      else {
        jsonObj = {
          "assignedToUpdate": this.commonService.trimAssignedToAI(obj),
          "assignedTo": this.commonService.trimAssignedToList(obj, curTaskStatus),
          "taskStatus": curTaskStatus,
          "dueDateStr": this.commonService.trimActionItemDueDate(obj),
          //"notes": "",
          "meetingId": meetingId,
          "minutesId": actionItemId?.replace("T_", ""),
          //"actionItemId": actionItemId,
          // "meetingTitle": $("#topMeetTitle").text(),
          "taskTitle": this.commonService.trimNoteDesc(obj, environment.taskEntityType, ""),
          "agendaId": entityId,
          "guestOwnerName": this.commonService.guestAssignedToAI(obj),
          // "isPrivate": obj.getAttribute("isPrivate") != undefined ? obj.getAttribute("isPrivate") : "N",
          "noteTypeId": this.globals.comNoteTypeId,
          "noteTypeCode": this.globals.comNoteTypeCode,
          "taskId": obj.getAttribute("taskId"),
          "taskEditFrom": "MT",
          "userId": this.globals.userId,
          "visitorTimeZone": this.globals.vTimeZone,
          "deletedFlag": 0,
        };
      }
      var saveUrl = this.getSaveUrl("Y", environment.taskEntityType, jsonObj);
      this.saveMinutesAttributes(data, jsonObj, saveUrl, "Y")
        .then((result: any) => {
          //

          this.sendUpdatedActionItem(obj, result);
          var infoToUpdate = jsonObj;

          infoToUpdate.noteDescription = jsonObj.taskTitle;
          infoToUpdate.noteId = obj.getAttribute("curNoteId");
          infoToUpdate.minutesId = obj.getAttribute("curNoteId");
          infoToUpdate.agendaId = obj.getAttribute("curAgendaId");
          infoToUpdate.meetingId = obj.getAttribute("curMeetingId");
          if (infoToUpdate.noteId != undefined || infoToUpdate.noteId != null) {
            saveUrl = this.getSaveUrl("Y", environment.noteEntityType, infoToUpdate);
            this.saveMinutesAttributes(data, infoToUpdate, saveUrl, "Y").then((minRes: any) => {
              result.lastModifiedName = minRes.lastModifiedName;
              result.lastModifiedOn = minRes.lastModifiedOn;
              this.sendUpdatedActionItem(obj, result);

            });
          }


          return result;
        });

    }

  }
  sendUpdatedActionItem(obj: HTMLElement, additionalJsonObj: any) {
    this.taskUpdateSource.next({ taskVal: additionalJsonObj });
    this.editCollabData = <MinutesCollabDetails>{};
    var actionItemId = obj.getAttribute("minid");
    var entityId = obj.getAttribute("agid");
    var curTaskStatus: any = "";
    var meetingId: any = this.meetingResponse.meetingId;//this.meetingId;//$("#meetingId").val();
    curTaskStatus = document.getElementById("taskStausCheckBox" + actionItemId)?.getAttribute("actualAIStatus");
    if (curTaskStatus == null || curTaskStatus == "" || curTaskStatus == undefined || curTaskStatus == "undefined" || curTaskStatus == "null") {
      curTaskStatus = environment.pendingStatus;
    }

    //this.meetingResponse.elementId=obj.getAttribute("id");
    this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
      var newMinList: any = [];
      if (agElem.agendaId == entityId) {
        this.editCollabData.agElemPosition = agIndex;
        if ((actionItemId == null || actionItemId == undefined)) {
          newMinList.push(additionalJsonObj);// if agenda and min there. but created from agenda then need to append at the beginning of agenda
        }
        if (agElem.minutesList != null && agElem.minutesList != undefined) {
          agElem.minutesList.forEach((minElem: any, minIndex: any) => {
            if (minElem.taskId != null && minElem.taskId == actionItemId) {
              var newTitle = this.commonService.trimNoteDesc(obj, environment.taskEntityType, "");
              minElem.taskTitle = newTitle;
              minElem.actionItemOwner = additionalJsonObj.actionItemOwner;
              minElem.actionItemOwnerList = additionalJsonObj.actionItemOwnerList;
              minElem.dueDateStr = additionalJsonObj.dueDateStr;
              minElem.dueDate = additionalJsonObj.dueDate;
              minElem.lastModifiedName = additionalJsonObj.lastModifiedName;
              minElem.lastModifiedOn = additionalJsonObj.lastModifiedOn;
              newMinList.push(minElem);
              this.editCollabData.minElemPosition = minIndex;
              this.editCollabData.elementVal = minElem;
            } else {
              newMinList.push(minElem);
            }
          });
        }
        // this.editCollabData.agElemPosition = agIndex;
        this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there 
      } else {
        if ((actionItemId == null || actionItemId == undefined)) {
          newMinList.push(additionalJsonObj);// if agenda and min there. but created from agenda then need to append at the beginning of agenda
        }
        if (agElem.minutesList != null && agElem.minutesList != undefined) {
          agElem.minutesList.forEach((minElem: any, minIndex: any) => {
            if (minElem.noteId != null && minElem.noteId == obj.getAttribute("curnoteid")) {
              minElem.lastModifiedName = additionalJsonObj.lastModifiedName;
              minElem.lastModifiedOn = additionalJsonObj.lastModifiedOn;
              newMinList.push(minElem);
              this.editCollabData.minElemPosition = minIndex;
              this.editCollabData.elementVal = minElem;
            } else {
              newMinList.push(minElem);
            }
          });
        }
        // this.editCollabData.agElemPosition = agIndex;
        this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there             
      }
    });
    this.meetingResponse.agendaList = this.meetingAgendaList;
    this.editCollabData.collabType = 'MIN';
    this.editCollabData.meetingId = this.meetingResponse.meetingId;
    if (actionItemId != undefined) {
      this.editCollabData.elementId = actionItemId;
    }
    //
    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      this.editCollabData.meetTypeVal = this.meetingResponse.meetingType;
    }

    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.editCollabData).subscribe((data) => {
      //
    });
  }

  pushDeleteMinutes(agId: any, minId: any) {

    this.minuteCollabData = <MinutesCollabDetails>{};
    this.minuteCollabData.agElementId = agId;
    this.minuteCollabData.collabType = 'MINDELETE';
    this.minuteCollabData.elementId = minId;
    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      this.minuteCollabData.meetTypeVal = this.meetingResponse.meetingType;
    }

    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.minuteCollabData).subscribe((data) => {
      //
    });

  }


  updateActionItemFromLoadAssignee(obj: HTMLElement, additionalJsonObj: any) {

    var data: any = {};
    var updatedResult: any = {};

    var actionItemId = obj.getAttribute("minid");
    var entityId = obj.getAttribute("agid");
    var meetingId: any = this.meetingResponse.meetingId;//this.meetingId;//$("#meetingId").val();
    if (actionItemId != null && actionItemId != "" && actionItemId != undefined && actionItemId != "undefined" && entityId != null && entityId != undefined) {
      var curTaskStatus: any = "";
      curTaskStatus = document.getElementById("taskStausCheckBox" + actionItemId)?.getAttribute("actualAIStatus");
      if (curTaskStatus == null || curTaskStatus == "" || curTaskStatus == undefined || curTaskStatus == "undefined" || curTaskStatus == "null") {
        curTaskStatus = environment.pendingStatus;
      }
      if (obj.getAttribute("isFollowUpFlag") == "Y") { // if the minutes belongs to followup then here we are overriding min, agenda,and meeting Id
        entityId = obj.getAttribute("prevAgendaId");
        meetingId = obj.getAttribute("prevMeetingId");
        actionItemId = obj.getAttribute("prevMinuteId");
      }
      data.agendaId = entityId;
      var jsonObj: any = {
        "assignedToUpdate": this.commonService.trimAssignedToAI(obj),
        "assignedTo": this.commonService.trimAssignedToList(obj, curTaskStatus),
        "taskStatus": curTaskStatus,
        "dueDateStr": this.commonService.trimActionItemDueDate(obj),
        //"notes": "",
        "meetingId": meetingId,
        "minutesId": actionItemId?.replace("T_", ""),
        //"actionItemId": actionItemId,
        // "meetingTitle": $("#topMeetTitle").text(),
        "taskTitle": this.commonService.trimNoteDesc(obj, environment.taskEntityType, ""),
        "agendaId": entityId,
        "guestOwnerName": this.commonService.guestAssignedToAI(obj),
        // "isPrivate": obj.getAttribute("isPrivate") != undefined ? obj.getAttribute("isPrivate") : "N",
        "noteTypeId": this.globals.comNoteTypeId,
        "noteTypeCode": this.globals.comNoteTypeCode,
        "taskId": obj.getAttribute("taskId"),
        "taskEditFrom": "MT",
        "userId": this.globals.userId,
        "visitorTimeZone": this.globals.vTimeZone,
        "deletedFlag": 0
      };

      var saveUrl = this.getSaveUrl("Y", environment.taskEntityType, jsonObj);
      this.saveMinutesAttributes(data, jsonObj, saveUrl, "Y")
        .then((result: any) => {
          updatedResult = result;
          return updatedResult;
        });
    }

  }

  //to construct note/decision/task while creating first time
  pushMinutesConstruction(jsonData: any, obj: any) {

    return new Promise((resolve, reject) => {
      var elem: any = "";

      if (jsonData.insertAtLast != null && jsonData.insertAtLast != "" && jsonData.insertAtLast != undefined && jsonData.insertAtLast == "Y") {
        if ($(obj).parents(".agendaRoot").find(".minMainCls:last-child").length > 0) {
          elem = $(obj).parents(".agendaRoot").find(".minMainCls:last-child").last();
        } else if ($(obj).parents(".agendaRoot").find(".agendaMainCls:last-child").length > 0) {
          elem = $(obj).parents(".agendaRoot").find(".agendaMainCls:last-child").last();
        }
      } else {
        if ($(obj).hasClass("minComCls")) {
          elem = $(obj).parents(".minMainCls");

        } else if ($(obj).hasClass("agendaTitleCls")) {

          elem = $(obj).parents(".agendaMainCls");

        } else {
          elem = $(obj);

        }
      }
      var currAgendaId = $(elem).attr("agid");
      var curMinId = $(elem).attr("minid");
      if (this.utilService.nvl($(elem).attr("isFollowUpFlag")) == 'Y') {
        currAgendaId = $(elem).attr("curAgendaId");
        curMinId = $(elem).attr("curNoteId");
      }


      this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {

        var newMinList: any = [];
        if (agElem.agendaId == currAgendaId) {
          if ((curMinId == null || curMinId == undefined)) {
            newMinList.push(jsonData);// if agenda and min there. but created from agenda then need to append at the beginning of agenda
          }

          if (agElem.minutesList != null && agElem.minutesList != undefined) {
            agElem.minutesList.forEach((minElem: any, minIndex: any) => {
              newMinList.push(minElem);
              if ((minElem.noteId != null && minElem.noteId == curMinId) || (minElem.decisionId != null && minElem.decisionId == curMinId) || (minElem.taskId != null && minElem.taskId == curMinId)) {
                this.meetingResponse.minElemPosition = minIndex;
                newMinList.push(jsonData);
              }
            });
          }
          this.meetingResponse.agElemPosition = agIndex;
          this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there 
        }
      });
      this.meetingResponse.agendaList = this.meetingAgendaList;
      this.agendaResp.next(this.meetingAgendaList);
      resolve(this.meetingAgendaList);
    });
  }

  //Method to update Minutes(Notes/decision/task)
  updateModernMinutesSeq(obj: any) {

    var pageIns = this;
    if ($(obj).parents(".agendaRoot").length > 0) {
      var agendaId = $(obj).parents(".agendaRoot").attr("agid");
      if (this.utilService.nvl(agendaId) != "") {
        var minSequenceMap: any = new Object();
        $(obj).parents(".agendaRoot").find(".minComCls").each(function (index: any, elem: any) {
          var minid = $(elem).attr("minid");
          if ($(elem).attr("curNoteId") != undefined) {
            minid = $(elem).attr("curNoteId");
          }
          if (pageIns.utilService.nvl(minid) != "") {
            var seq = index + 1;
            minSequenceMap[seq] = minid;
          }
        });
        var minSeqList = JSON.stringify(minSequenceMap);
        var jsonReq = { "meetingId": this.meetingResponse.meetingId, "minSequenceList": minSeqList, "agendaId": agendaId };
        this.meetingService.updateMinSequence(JSON.stringify(jsonReq)).subscribe(res => {
          var minutesResp = res.body;
        });
      }
    }

  }
  //Method to remove array from list
  popMinList(removeAgId: any, removeMinId: any) {
    this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
      var newMinList: any = [];
      if (agElem.agendaId == removeAgId) {
        if (agElem.minutesList != null && agElem.minutesList != undefined) {
          agElem.minutesList.forEach((minElem: any, minIndex: any) => {
            newMinList.push(minElem);
            if ((minElem.noteId != null && minElem.noteId == removeMinId) || (minElem.decisionId != null && minElem.decisionId == removeMinId) || (minElem.taskId != null && minElem.taskId == removeMinId)) {
              newMinList.pop();
            }
          });
          this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there 
          //this.meetingResponse.agendaList = this.meetingAgendaList;
        }
        this.meetingResponse.agendaList = this.meetingAgendaList;
        this.agendaResp.next(this.meetingAgendaList);
      }
    });
  }
  /// method to load task edit assign and agenda edit assign
  loaTaskEditAssignandAgEditPresenter(removeDup: any, code: any, obj: any) {
    return new Promise((resolve, reject) => {
      var assignedTo: any;
      //$(obj).preventDefault();
      //$(obj).off("blur");
      this.attendeeService.loadAttendeeAgendaPresenter(removeDup, code, obj)
        .then(($inputor: any) => {
          var pageIns = this;
          $inputor.off("inserted.atwho");
          $inputor.on("inserted.atwho", (event: any, $li: any, query: any) => {
            if ($li.length != 0) {

              if (code == "AGTASKEDT") {

                $('.atwho-inserted:first', obj);
                $('.atwho-inserted:first', obj).before("<span class='presentedByCls' contentEditable='false'>, </span>");

                assignedTo = {
                  "userId": $li.data('item-data').id,
                  "username": $li.data('item-data').value,
                }
                pageIns.assignedTo = assignedTo;

              } else if (code == "AGEDT") {

                $('.atwho-inserted:first', obj);
                $('.atwho-inserted:first', obj).before("<span class='presentedByCls' contentEditable='false'>, </span>");
                assignedTo = {
                  "userId": $li.data('item-data').id,
                  "userName": $li.data('item-data').value,
                }
                pageIns.assignedTo = assignedTo;
              }
              resolve(pageIns.assignedTo);
            }
          });
        });
    });

  }
  reassignTask() {
    return this.assignedTo;

  }
  addTasktoUser() {
    return this.assignedTo;

  }
  agendaPresenter() {

    return this.assignedTo;
  }
  //Method to load task assignee and agendapresenter
  loadTaskAssigneeAndAgPresenter(removeDup: any, code: any, obj: any) {

    this.presentLoad = true;
    this.attendeeService.loadAttendeeAgendaPresenter(removeDup, code, obj)
      .then(($inputor: any) => {
        // this.presentLoad = true;

        var pageIns = this;
        $inputor.off("inserted.atwho");
        $inputor.on("inserted.atwho", function (event: any, $li: any, query: any) {
          if ($li.length != 0) {
            if (code == "AG") {
              let addAttendeejsonobj = {
                "attendeeName": $li.data('item-data').value,
                "attendeeEmail": $li.data('item-data').email,
                "fkCodelstAttendeeRole": 9,
                "attendeeIsPresent": environment.AttendeeIsPresent,
                "attendeeId": "",
                "fkSecUserAttendee": $li.data('item-data').id,
                "attendeeRole": "Attendee",
                "createdBy": 0,
                "attendeeRoleCode": environment.defAttendeeRoleCode,
                "logType": "IN",
                "deletedFlag": 0,
                "availableStatus": "",
                "meetingId": pageIns.meetingResponse.meetingId,
                "isJoined": ""
              }

              var fkuserIdVal: any = []
              pageIns.meetingResponse.attendeeList?.forEach((attendees: any) => {
                var x = attendees.attendeeName;

                var y: any = x;

                fkuserIdVal.push(y);
              });
              var a = addAttendeejsonobj.attendeeName;

              var b: any = a;

              if (fkuserIdVal.includes(b) == false) {


                pageIns.attendeeService.addAttendee(addAttendeejsonobj).subscribe((data: any) => {

                  var attObj = addAttendeejsonobj;
                  attObj["attendeeId"] = data.attendeeId;
                  attObj["fkCodelstAttendeeRole"] = data.fkCodelstAttendeeRole;
                  attObj["attendeeIsPresent"] = data.attendeeIsPresent;
                  attObj["attendeeRole"] = data.attendeeRole;
                  attObj["createdBy"] = data.createdBy;
                  attObj["deletedFlag"] = data.deletedFlag;
                  attObj["logType"] = "IN";
                  attObj["isJoined"] = "";
                  pageIns.meetingResponse.attendeeList?.push(attObj);


                });
              }

              if ($(obj).children('span.presentedByCls').length == 0 && obj.classList.contains("agendaTitleCls")) {
                $('.atwho-inserted:first', obj).before("<span class='presentedByCls' contentEditable='false'>Presented by </span>");

              }

              if (obj != null && $(obj) != null && $(obj).hasClass("agendaTitleCls")) {
                var agId = $(obj).attr("agid");
                if (agId != null && agId != "" && agId != undefined) {
                  $('.atwho-inserted:last', obj).after("&nbsp;");
                  pageIns.updateAgenda($("#meetAgendaId" + agId), null, 'B');
                  $("#meetAgendaId" + agId).focus();
                  setTimeout(function () {
                    $("#meetAgendaId" + agId).focus();
                    pageIns.utilService.placeCaretAtEnd($("#meetAgendaId" + agId).get(0));
                  }, 500);
                }
              }
              //pageIns.updateActionItem(obj, {});
            } else if (obj != null && obj.classList.contains("agChildTask")) {

              if ($(obj).children('span.assignCls').length == 0 && obj.classList.contains("agChildTask")) {
                $('.atwho-inserted:first', obj).before("<span class='assignCls' contentEditable='false'>Owner(s): </span>");
              }
              //
              pageIns.updateActionItemFromLoadAssignee(obj, {});
            }
            //addEscapeChar(obj);
            if (event != undefined && event != null && typeof event.cancel === 'function') {
              event.cancel();
            } else if (event != undefined && event != null && typeof event.preventDefault === 'function') {
              event.preventDefault();
            }
          }
        });
      });
  }

  //Method to save/update Minutes(note/decision/task) not for task update
  createEmptyMinutes(data: any, entityType: any, obj: HTMLElement, isUpdate: any) {
    return new Promise((resolve, reject) => {


      var agendaId = data.agendaId;
      var minId = "";
      var noteDesc = "";
      var isPrivate = "N";
      var isDefaultNotes = "";
      var prevnoteType = "";
      var createdBy = this.globals.userId;
      var isFollowUpFlag = "";
      var noteId = "";
      var decisionId = "";
      var taskId = "";
      var saveUrl = "";
      var ispreviews = "";
      if (isUpdate != "Y") {//to save min
        noteDesc = '<br/>';
        isPrivate = "N";
      } else if (obj != undefined) {//to update min
        minId = data.minutesId;
        noteId = data.noteId;
        decisionId = data.decisionId;
        isPrivate = data.isPrivate;
        taskId = data.taskId;
        createdBy = data.createdBy;
        if (obj != null) {
          if (obj.innerHTML.trim().replace(/\s+/g, '') == "") {
            obj.innerHTML = "<br/>";

          }
        }



        noteDesc = this.commonService.trimNoteDesc(obj, entityType, null);

      }
      if (data != null && data != undefined && data["isCopied"] != undefined && data["isCopied"] == "Y") {

        noteDesc = data.noteDescription;
      }
      if (data != null && data != undefined && data["isDefaultNotes"] != undefined && data["isDefaultNotes"] == "1" && data["isDefaultNotes"] == 1) {
        isDefaultNotes = data["isDefaultNotes"];
      }
      if (data != null && data != undefined && data["prevnoteType"] != undefined) {

        prevnoteType = data.prevnoteType;
      }

      if (data != null && data != undefined && data["isPreviews"] != undefined) {

        ispreviews = data.isPreviews;
      }

      var jsonObj: any = {};
      if (this.meetingResponse.isConfidential == "Y") {

        jsonObj = {
          "prevMinuteId": data.minutesId,
          "noteDescription": this.commonService.toParseImgNoteDesc(noteDesc),
          "agendaId": agendaId,
          "meetingId": this.meetingResponse.meetingId,
          "entityType": entityType,
          "isPrivate": isPrivate,
          // "isPrivate": obj.getAttribute("isPrivate") != undefined ? obj.getAttribute("isPrivate") : "N",
          // "isprivate": data.isprivate === "Y" ? "Y" : "N",
          //"isConfidential": "",
          "minutesId": minId,
          "prevNoteType": prevnoteType,
          "createdBy": createdBy,
          "isFollowUpFlag": isFollowUpFlag,
          // "createdOn": "",
          // "prevLastModifiedOn": "",
          //"movingToAgendaId": movingToAgendaId,
          //"noDirtyCommit": "Y",
          "userId": this.globals.userId,
          "deletedFlag": 0,
          "isDefaultNotes": isDefaultNotes,
          "noteTypeId": this.globals.comNoteTypeId,
          "noteTypeCode": this.globals.comNoteTypeCode,
          "noteId": noteId,
          "decisionId": decisionId,
          "taskId": taskId,
          "rowStatus": "",
          "isPreNote": ispreviews,
          "isConfidential": this.meetingResponse.isConfidential,
          "encryptKey": localStorage.getItem("savedpasswords" + "_" + this.meetingResponse.meetingId),
        }
      }
      else {

        jsonObj = {
          "prevMinuteId": data.minutesId,
          "noteDescription": this.commonService.toParseImgNoteDesc(noteDesc),
          "agendaId": agendaId,
          "meetingId": this.meetingResponse.meetingId,
          "entityType": entityType,
          "isPrivate": isPrivate,
          // "isPrivate": obj.getAttribute("isPrivate") != undefined ? obj.getAttribute("isPrivate") : "N",
          //"isConfidential": "",
          "minutesId": minId,
          "prevNoteType": prevnoteType,
          "createdBy": createdBy,
          "isFollowUpFlag": isFollowUpFlag,
          // "createdOn": "",
          // "prevLastModifiedOn": "",
          //"movingToAgendaId": movingToAgendaId,
          //"noDirtyCommit": "Y",
          "userId": this.globals.userId,
          "deletedFlag": 0,
          "isDefaultNotes": isDefaultNotes,
          "noteTypeId": this.globals.comNoteTypeId,
          "noteTypeCode": this.globals.comNoteTypeCode,
          "noteId": noteId,
          "decisionId": decisionId,
          "taskId": taskId,
          "rowStatus": "",
          "isPreNote": ispreviews,
          //"isConfidential":this.meetingResponse.isConfidential,
          //"decryptKey":localStorage.getItem("savedpasswords"),
          "privAgId": obj.getAttribute("parentAgendaId") != undefined ? obj.getAttribute("parentAgendaId") : agendaId,

        }
      };
      if (entityType == environment.taskEntityType) {

        jsonObj.taskTitle = jsonObj.noteDescription;
        jsonObj.noteDescription = "";
        jsonObj.dueDate = "";
        jsonObj.assignedTo = "";
        jsonObj.taskStatus = environment.pendingStatus;
      }
      saveUrl = this.getSaveUrl(isUpdate, entityType, jsonObj)
      this.saveMinutesAttributes(data, jsonObj, saveUrl, isUpdate)
        .then((result: any) => {



          resolve(result);
        });
    });

  }

  //Method to delete  agenda
  deleteAgenda(agendaId: any) {

    var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utilService.featureList.AGENDA, this.utilService.permissionType.DELETE);

    if (!roleFlag) {
      return;
    }
    if ($("#agendaMainId" + agendaId).parent(".agendaRoot").find(".minComCls").length > 0) {
      this.notifier.show({
        type: 'warning',
        message: "Agenda should not contain minutes."
      });
      // alert("Agenda should not contain minutes.")
      // this.notifier.notify('warning', 'Agenda should not contain minutes.');
    } else if ($(".agendaMainCls").length <= 1) {
      this.notifier.show({
        type: 'warning',
        message: "Atleast one agenda should be there."
      });
      // alert("Atleast one agenda should be there.");
      // this.notifier.notify('warning', 'Atleast one agenda should be there.');
    } else {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          dialogTitle: "Confirmation",
          dialogContent: environment_msg.msg_confirm_delete_agenda
        },
      }).afterClosed().subscribe((response: any) => {
        var conAgendaDel = response

        if (conAgendaDel) {

          this.meetingService.deleteModernAgenda(this.meetingResponse.meetingId, agendaId).subscribe(res => {
            var agResp = res.body;
            if (agResp != null && (agResp.deletedFlag == "1" || agResp.deletedFlag == 1)) {
              // alert("Agenda deleted successfully");
              // this.notifier.notify('success', 'Agenda deleted successfully');
              this.popAgendaList(agendaId);
            } else if (agResp != null && this.utilService.nvl(agResp.errorMessage) != "") {
              alert(agResp.errorMessage);
              // this.notifier.notify('error', agResp.errorMessage);
            }
          });
        }
      });
    }
  }
  //incase of empty agenda section atleast place break tag and append space to place curdor
  constructFocusHolderForAgenda(event: any) {

    var pageIns = this;
    var targetElem: HTMLElement = event.target;
    if (targetElem.innerHTML != undefined && targetElem.innerHTML.trim().replace(/\s+/g, '') == "") {
      targetElem.innerHTML = "<br/>";
    }
    var minContent = targetElem.innerHTML;
    if (minContent != undefined) {
      pageIns.utilService.addEscapeChar(targetElem);
    }
  }
  constructFocusHolderForAgendaForMLeave(event: any) {

    var pageIns = this;
    var targetElem: HTMLElement = event.target;
    if (targetElem.innerHTML != undefined && targetElem.innerHTML.trim().replace(/\s+/g, '') == "") {
      targetElem.innerHTML = "<br/>";
    }
    var minContent = targetElem.innerHTML;
    if (minContent != undefined) {
      pageIns.utilService.addEscapeChar(targetElem);
    }
  }
  //Method to get save url of note/decision/task
  getSaveUrl(isUpdate: any, entityType: any, jsonObj: any) {
    var serviceUrl = "";
    if (entityType == environment.noteEntityType) {

      if (isUpdate != "Y") {
        serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.note + "saveNote";
      } else {
        serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.note + "editNote/" + jsonObj.minutesId;
      }
    } else if (entityType == environment.decisionEntityType) {


      if (isUpdate != "Y") {
        serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.decision + "saveDecision";
      } else {
        serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.decision + "editDecision/" + jsonObj.minutesId;
      }
    } else {

      if (isUpdate != "Y") {
        serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.task + "saveTask";
      } else {
        serviceUrl = this.agoraConfig.getConfig().apiBaseUrl + this.agoraConfigObject.task + "updateTaskInfo";
      }
    }
    return serviceUrl;
  }
  //method to push agenda duration
  pushAgendaDuration(agendaId: any, agendaDuration: any) {
    var agList: any = [];
    this.meetingAgendaList?.forEach((agElem: any, agIndex: any) => {
      if (agElem.agendaId == agendaId) {
        agElem.agendaDuration = agendaDuration;
      }
      agList.push(agElem);
    });
    this.meetingAgendaList = agList;
    this.meetingResponse.agendaList = this.meetingAgendaList;
  }

  //to invoke save minutes attribute service

  private saveQueue = Promise.resolve(); // shared promise chain

  saveMinutesAttributes(data: any, jsonObj: any, saveUrl: any, isUpdate: any) {
    const minJsonString = JSON.stringify(jsonObj);

    // Chain new call onto previous promise
    this.saveQueue = this.saveQueue.then(() => {
      return new Promise((resolve, reject) => {
        this.meetingService.saveModernMinutes(minJsonString, saveUrl, isUpdate)
          .subscribe({
            next: res => {
              const minutesResp = res.body;
              if (minutesResp) {
                data = { ...data, ...jsonObj, ...minutesResp };
                data.minutesId = minutesResp._id;
              }
              resolve(data);
            },
            error: err => {
              console.error("Save failed:", err);
              reject(err);
            }
          });
      });
    });

    // Return the queued promise (so caller can still await it)
    return this.saveQueue;
  }

  noteDecisionDatepicker(inlineEditor: any) {
    var pageIns = this;
    $('.minDateCls').off("click");
    $('.minDateCls').on("click", function (event: any) {
      if (!(event.target.firstChild.data == 'Next' || event.target.firstChild.data == 'Prev')) {
        pageIns.utilService.removeDuplicateIdFromDate();
      }

      if (inlineEditor != null && inlineEditor != undefined) {
        inlineEditor.focusManager.blur(true);
      }
      var code = $(event.target).attr("code");

      pageIns.displayDatepicker(event.target, code, event);
    });
  }
  //to display datepicker to change due date
  displayDatepicker(obj: any, code: any, event: any) {
    var isDatePickerVisible = $(obj).find(".ui-datepicker").is(":visible");
    var pageIns = this;
    if (!isDatePickerVisible) {
      var date = $(obj).clone().children().remove().end().text();
      $(obj).datepicker("destroy");
      $(obj).html("");
      var aiTimeZone = "";
      if (code == "AI") {
        if (this.globals.showTimezone_Date == "Y") {
          aiTimeZone = "<span class='taskTimezoneCls'> " + this.globals.vShortTimeZone + "</span>";
        }
        $(obj).append("<span class='dueLabelCls'>Due Date: </span>" + date + aiTimeZone);
      } else {
        $(obj).append(date);
      }

      var defDate = pageIns.utilService.getCurDateWithoutTime();
      if (pageIns.utilService.nvl(date) != "") {
        defDate = new Date(date);
      }
      $(obj).datepicker({
        localToday: pageIns.utilService.getCurDateWithoutTime(),
        //defaultDate: pageIns.utilService.getCurDateWithoutTime(),
        defaultDate: defDate,
        //setDate: pageIns.utilService.getCurDateWithoutTime(),
        setDate: defDate,
        //minDate: pageIns.utilService.getCurDateWithoutTime(),
        dateFormat: 'M dd, yy',
        autoclose: true,
        beforeShow: function (input: any, inst: any) {
          setTimeout(function () {
            $(".ui-datepicker-inline").hide();
            //
            inst.dpDiv.css("display", "block");
            inst.dpDiv.position({
              my: 'right top',
              at: 'right bottom',
              within: "#editable",
              of: $(obj)
            });
          }, 1);
        },
        onSelect: function () {
          $(obj).html("");
          if (code == "AI") {
            $(obj).append("<span class='dueLabelCls'>Due Date: </span>" + $.datepicker.formatDate("M dd, yy", $(this).datepicker('getDate')) + aiTimeZone);
          } else {
            $(obj).append($.datepicker.formatDate("M dd, yy", $(this).datepicker('getDate')));
          }
          $(obj).parent(".minComCls").focus();
          pageIns.utilService.placeCaretAtEnd($(obj).parent(".minComCls").get(0));
        }, onClose: function () {
          $(obj).removeClass("hasDatepicker");
          $(obj).parent(".minComCls").blur();
          pageIns.utilService.removeDuplicateIdFromDate();
        }
      });
    }
  }

  //Method to insert last comma  on focus
  insetrLastCommaFromConstruct(elem: any) {

    $("#insertAttendeeSec").find('.atwho-query').contents().unwrap();
    if ($(elem).hasClass("minComCls")) {
      $(".agendaTitleCls").find('.atwho-query').contents().unwrap();
    } else if ($(elem).hasClass("agendaTitleCls")) {
      $(".minComCls").find('.atwho-query').contents().unwrap();
    }
    if ($(elem).hasClass("agChildTask") || $(elem).hasClass("agendaTitleCls")) {//code added to add comma at end(Note/decision/task/agenda) on focus
      if ($('.atwho-inserted:last', elem).length != 0) {

        var lastStr = this.utilService.removeLastString($('.atwho-inserted:last', elem).text(), ",");
        $('.atwho-inserted:last', elem).text(lastStr.trim() + ",");
      }
    }
  }
  //Method to insert last comma  on blur
  removeLastCommaFromConstruct(obj: any) {
    if ($(obj).hasClass("agChildTask") || $(obj).hasClass("agendaTitleCls")) {
      if ($('.atwho-inserted:last', obj).length != 0) {
        var lastStr = this.utilService.removeLastString($('.atwho-inserted:last', obj).text(), ",");
        $('.atwho-inserted:last', obj).text(lastStr + " ");
      }
    }
  }
  //used to update task from task edit dialog box
  updateTaskFromDialog(updatedValue: any, curTaskUiInfo: any) {
    // //

    var data: any = {};
    var saveUrl = this.getSaveUrl("Y", environment.taskEntityType, updatedValue);
    this.saveMinutesAttributes(data, updatedValue, saveUrl, "Y")
      .then((result: any) => {
        this.curStatus.next(result);
        if (curTaskUiInfo.isFollowUpFlag == 'Y') {
          var infoToUpdate = curTaskUiInfo;
          infoToUpdate.noteDescription = updatedValue.taskTitle;
          infoToUpdate.minutesId = curTaskUiInfo.noteId;
          infoToUpdate.followUpTaskInfo = result;
          // infoToUpdate.followUpTaskInfo.tasktitle=updatedValue.taskTitle;
          // infoToUpdate.followUpTaskInfo.actionItemOwner=updatedValue.actionItemOwner;
          // infoToUpdate.followUpTaskInfo.dueDateStr=updatedValue.dueDateStr;
          // infoToUpdate.followUpTaskInfo.dueDate=updatedValue.dueDate;
          //infoToUpdate.taskTitle=updatedValue.taskTitle;
          saveUrl = this.getSaveUrl("Y", environment.noteEntityType, infoToUpdate);
          this.saveMinutesAttributes(data, infoToUpdate, saveUrl, "Y").then((minRes: any) => {
            this.popUpdatedTaskValue(curTaskUiInfo.followUpTaskInfo.agendaId, curTaskUiInfo.followUpTaskInfo.taskId, infoToUpdate);
          });
        } else {
          this.popUpdatedTaskValue(result.agendaId, result.minutesId, result);
        }
        this.taskUpdateSource.next({ taskVal: result });
      });
  }

  //used to update task from dashboard popup

  updateTaskFromPopup(updatedValue: any) {
    var data: any = {};
    var saveUrl = this.getSaveUrl("Y", environment.taskEntityType, updatedValue)
    this.saveMinutesAttributes(data, updatedValue, saveUrl, "Y")
      .then((result: any) => {
        this.popUpdatedTaskValue(result.agendaId, result.minutesId, result)
      });
  }

  // method is used to set updated value in task
  popUpdatedTaskValue(removeAgId: any, removeMinId: any, result: any) {
    this.editCollabData = <MinutesCollabDetails>{};
    this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
      var newMinList: any = [];
      if (agElem.agendaId == removeAgId) {
        if (agElem.minutesList != null && agElem.minutesList != undefined) {
          agElem.minutesList.forEach((minElem: any, minIndex: any) => {
            minElem.rowStatus = "";
            newMinList.push(minElem);
            if ((minElem.noteId != null && minElem.noteId == removeMinId) || (minElem.decisionId != null && minElem.decisionId == removeMinId) || (minElem.taskId != null && minElem.taskId == removeMinId)) {
              newMinList.pop();
              // newMinList.push(minElem);
              newMinList.push(result);
              this.editCollabData.minElemPosition = minIndex;
            }
          });
          this.editCollabData.agElemPosition = agIndex;
          this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there 
        }

      }
      this.meetingResponse.agendaList = this.meetingAgendaList;
      this.editCollabData.collabType = 'MIN';
      this.editCollabData.elementId = removeMinId;
      this.editCollabData.meetingId = this.meetingResponse.meetingId;
    });
    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      this.editCollabData.meetTypeVal = this.meetingResponse.meetingType;
    }

    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.editCollabData).subscribe((data) => {
      //

    });

  }

  //used to update agenda from edit box
  updateAgendaEditbox(agendaEditBoxValue: any, agendaId: any) {
    return new Promise((resolve, reject) => {
      this.meetingService.updateModernAgenda(agendaEditBoxValue, agendaId).subscribe((res: { body: any }) => {
        var resp = res.body;
        this.pushUpdatedAgendaConstruction(resp, agendaId)
          .then((updatedList: any) => {
            resolve(updatedList);
          })
          .catch((err) => reject(err));
      }, (error) => reject(error));
    });
  }

  // Used to set the resp value for agenda section
  pushUpdatedAgendaConstruction(jsonData: any, agendaId: any) {
    return new Promise((resolve, reject) => {
      var reqJSON = { "meetingId": jsonData.meetingId, "agendaId": jsonData.agendaId };

      this.meetingService.fetchAgendaWithMinutes(reqJSON).subscribe((data: any) => {
        this.newAgList = data.body;
        var agList: any = [];
        this.meetingAgendaList.forEach((agElem: any) => {
          if (agElem.agendaId == jsonData.agendaId) {
            agList.push(this.newAgList); // Replace updated agenda
          } else {
            agList.push(agElem);
          }
        });
        this.meetingAgendaList = agList;
        this.meetingResponse.agendaList = this.meetingAgendaList;
        resolve(this.newAgList);
      }, (error) => reject(error));
    });
  }
  updateAgendaMinutes(data: any, entityType: any, obj: HTMLElement, isUpdate: any) {

    this.editCollabData = <MinutesCollabDetails>{};
    const pageIns = this;
    this.createEmptyMinutes(data, entityType, obj, isUpdate).then((jsonData: any) => {
      if (isUpdate == "Y") {
        var prevAgendaId = $(obj).attr("agid");
        var prevMinId = $(obj).attr("minid");

        this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
          var newMinList: any = [];
          if (agElem.agendaId == prevAgendaId) {
            if ((prevMinId == null || prevMinId == undefined)) {
              newMinList.push(jsonData);// if agenda and min there. but created from agenda then need to append at the beginning of agenda
            }
            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {
                if ((minElem.noteId != null && minElem.noteId == prevMinId) || (minElem.decisionId != null && minElem.decisionId == prevMinId) || (minElem.taskId != null && minElem.taskId == prevMinId)) {
                  newMinList.push(jsonData);
                  //this.meetingResponse.minElemPosition=minIndex;
                  this.editCollabData.minElemPosition = minIndex;
                  this.editCollabData.elementVal = jsonData;
                } else {
                  minElem.rowStatus = "";
                  newMinList.push(minElem);
                }
              });
            }
            //this.meetingResponse.agElemPosition=agIndex;
            this.editCollabData.agElemPosition = agIndex;
            this.meetingAgendaList[agIndex].minutesList = newMinList;//if agenda and min already there 
          }
          this.meetingResponse.agendaList = this.meetingAgendaList;
          this.editCollabData.collabType = 'MIN';
          const selObjId = obj.getAttribute("id");
          if (selObjId != null) {
            this.editCollabData.elementId = jsonData.minutesId;
          }
        });
      }

      //
      this.editCollabData.meetingId = this.meetingResponse.meetingId;
      if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
        this.editCollabData.meetTypeVal = this.meetingResponse.meetingType;
      }

      this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.editCollabData).subscribe((data) => {
        //

      });
    });
  }

  pushAttachmentCount(minDetails: any, attachCount: any, entityType: any) {
    this.minuteCollabData = <MinutesCollabDetails>{};
    let selMinId: any;
    if (entityType == "MN") {
      selMinId = minDetails.noteId;
    } else if (entityType == "MD") {
      selMinId = minDetails.decisionId;
    } else {
      selMinId = minDetails.taskId;
    }
    this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
      if (agElem.agendaId == minDetails.agendaId) {
        this.minuteCollabData.agElemPosition = agIndex;
        if (agElem.minutesList != null && agElem.minutesList != undefined) {
          agElem.minutesList.forEach((minElem: any, minIndex: any) => {
            if ((minElem.noteId != null && minElem.noteId == selMinId) || (minElem.decisionId != null && minElem.decisionId == selMinId) || (minElem.taskId != null && minElem.taskId == selMinId)) {
              this.minuteCollabData.minElemPosition = minIndex;
              this.minuteCollabData.elementVal = this.meetingAgendaList[agIndex].minutesList[minIndex];
              if (minElem.isFollowUpFlag == "Y") {
                this.meetingAgendaList[agIndex].minutesList[minIndex].followUpTaskInfo.attachmentTotalCnt = attachCount;
              } else {
                this.meetingAgendaList[agIndex].minutesList[minIndex].attachmentTotalCnt = attachCount;
              }
            } else {
              minElem.rowStatus = "";

            }
          });

        }
      }
    });
    this.minuteCollabData.attachmentTotalCnt = attachCount;
    this.minuteCollabData.collabType = 'MINATTACH';
    this.minuteCollabData.elementId = selMinId;
    if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
      this.minuteCollabData.meetTypeVal = this.meetingResponse.meetingType;
    }


    this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.minuteCollabData).subscribe((data) => {


    });
  }

  sendTypingNotification(elementId: any) {
    //
    this.webTranService.pushTypingNotification(this.meetingResponse.meetingId, this.meetingResponse, elementId).subscribe((data) => {
      //
    });
  }

  returnMinOrAgendaId(agendaId: any) {
    var returnId = "";
    var Ins = this;
    $(".agendaRoot").each(function (e: any) {
      if ($(Ins).attr("agid") != undefined && $(Ins).attr("agid") == agendaId) {

        if ($(Ins).find(".minComCls").length > 0) {
          returnId = $(Ins).find(".minComCls").last().attr("id");
        } else if ($(Ins).find(".agendaTitleCls").length > 0) {
          returnId = $(Ins).find(".agendaTitleCls").last().attr("id");
        }
      }
    });
    return returnId;
  }

  trackChangesWhileEditing(minId: any, agendaId: any, event: any, curMinEntitype: any, divId: any) {
    this.editCollabData = <MinutesCollabDetails>{};
    var roleFlag = this.permissionService.checkRoleRightsWithNoAlert(this.utilService.featureList.MINUTES, this.utilService.permissionType.MODIFY);

    if (!roleFlag) {
      var minutesService = this.injector.get(FreeFormMinutesService);
      minutesService.destroyCkInstane('minComCls');
      return
    }
    if (window.getSelection != null) {
      var textContent = window.getSelection()?.toString();
    }
    var date = (event.altKey && event.keyCode == 65);
    if (event.keyCode == 13 || date) {
      var minutesService = this.injector.get(FreeFormMinutesService);
      var obj = event.currentTarget as HTMLElement;
      if (date) {
        if (obj.classList.contains("agChildTask") || obj.classList.contains("agChildDecision") || obj.classList.contains("agChildNote")) {
          minutesService.replaceDueDate(obj, obj.getAttribute("entityType"), '');
          event.cancel();
        }
      }
      else {
        minutesService.activateCkeditor(obj);
      }

    }
    if (event.keyCode) {//for deleting minutes

      //activateCkeditor(this);
      var currentMinId = minId;
      var updateEntityType;
      var selectTextAsNote = (event.altKey && event.keyCode == 78);//(ALT+N)
      var selectTextAsDecision = (event.altKey && event.keyCode == 68);//(ALT+D)
      var selectTextAsTask = (event.altKey && event.keyCode == 84);//(ALT+T)
      var changeAsNote = (event.altKey && (event.keyCode == 49 || event.keyCode == 97));//(ALT+1)
      var changeAsDecision = (event.altKey && (event.keyCode == 50 || event.keyCode == 98));//(ALT+2)
      var changeAsTask = (event.altKey && (event.keyCode == 51 || event.keyCode == 99));//(ALT+3)
      var createAgenda = (event.altKey && event.keyCode == 71)

      if (createAgenda) {
        this.trackAgendaEventOnClick(event, 'AG');
      }

      //var delAsMinutes = (event.ctrlKey  &&  (event.keyCode == 68) && (this.utilService.nvl(notepadFlag=="Y");//(ALT+3)

      if ((selectTextAsNote) || (selectTextAsDecision) || (selectTextAsTask)) {
        var notes = event.target.textContent;
        if (agendaId != null && agendaId != undefined && agendaId != "" && agendaId != "null") {
          var jsonObj = {
            "noteDescription": textContent,
            "agendaId": agendaId,
            "createNewNote": "Y",
            "insertAtLast": "N",
            "isCopied": "Y"
          };

          var lastminId = this.returnMinOrAgendaId(agendaId);
          var jsonString = JSON.stringify(jsonObj);
          if (lastminId != undefined && lastminId != null && lastminId != "undefined" && lastminId != "null") {
            if (selectTextAsNote) {
              this.midMinutesConstruction(event, environment.noteEntityType, event.target, jsonObj);
            } else if (selectTextAsDecision) {
              this.midMinutesConstruction(event, environment.decisionEntityType, event.target, jsonObj);
            } else if (selectTextAsTask) {
              this.midMinutesConstruction(event, environment.taskEntityType, event.target, jsonObj);
            }
          }
        }
        event.stopPropagation();
        event.preventDefault();
        // return false;
      } else if (changeAsNote || changeAsDecision || changeAsTask) {
        if (curMinEntitype == 'MN' && changeAsNote) {
          event.preventDefault();
          return
        }
        if (curMinEntitype == 'MD' && changeAsDecision) {
          event.preventDefault();
          return
        }
        if (curMinEntitype == 'AI' && changeAsTask) {
          event.preventDefault();
          return
        }
        var minChangeJson = {
          "prevnoteType": curMinEntitype,
          "minutesId": currentMinId,
          "convertMinutes": "Y",
          "isCopied": "Y",
          "noteDescription": event.target.innerHTML
        };

        if (curMinEntitype != "AI" && $(this).find(".minImageTag").length >= 1) {
          var conf = confirm($("#imgOverride").text());
          if (!conf) {
            // return false;
          }
          // $(this).find(".min_img_comn_cls").remove();
        }
        // $(".ui-datepicker").hide();
        var minutesService = this.injector.get(FreeFormMinutesService);


        if (changeAsNote) {
          updateEntityType = environment.noteEntityType;
        } else if (changeAsDecision) {
          updateEntityType = environment.decisionEntityType;
        } else if (changeAsTask) {
          updateEntityType = environment.taskEntityType;
        }

        this.convertEntities(event, updateEntityType, event.target, minChangeJson, divId);
        event.stopPropagation();
        event.preventDefault();
        // return false;

      }

      else {
        this.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
          if (agElem.agendaId == agendaId) {
            if (agElem.minutesList != null && agElem.minutesList != undefined) {
              agElem.minutesList.forEach((minElem: any, minIndex: any) => {
                if ((minElem._id != null && minElem._id == minId)) {

                  //this.meetingResponse.minElemPosition=minIndex;
                  this.editCollabData.minElemPosition = minIndex;
                  this.editCollabData.elementId = minId;
                }
              });
            }

            //this.meetingResponse.agElemPosition=agIndex;
            this.editCollabData.agElemPosition = agIndex;
          }
          this.editCollabData.collabType = 'MINEDIT';
          const sentUserName = localStorage.getItem("userName");
          if (sentUserName != null && sentUserName != undefined) {
            this.editCollabData.sentByUserName = sentUserName;
          }
          this.editCollabData.meetingId = this.meetingResponse.meetingId;
        });
        if (this.meetingResponse.meetingType != undefined && this.meetingResponse.meetingType != null && this.meetingResponse.meetingType != "") {
          this.editCollabData.meetTypeVal = this.meetingResponse.meetingType;
        }


        this.webTranService.pushMesssageToProducer(this.meetingResponse.meetingId, this.editCollabData).subscribe((data) => {

        });
      }
    }
  }



  //agenda link dialog
  statusTracker(id: any, vari: any) {

    if (vari != undefined) {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'false'
    }
    else {
      let element = (<HTMLElement>document.getElementById("agMinId" + id))
      element.contentEditable = 'true'
    }
  }

  //method to check 
  checkAgendaDurationExceed(curAgTime: any, agendaId: any) {
    // var meetDur:any = $(".mtngdur").val();
    return new Promise((resolve, reject) => {

      var total_mts: any = this.meetingResponse.duration;
      var ag_duration = 0;
      var newMeetDur = 0;
      var agTime = parseInt(curAgTime);

      //var conf=false;
      if ($(".agendaMainCls").length > 0) {
        $(".agendaMainCls").each(function (i: any, el: any) {
          var curDivAgid: any = $(el).find(".agendaTitleCls").attr("agid");
          var x: any = $(el).attr("agendatime");
          var agendaTime: number = +x;


          if (agendaTime != null && agendaTime != undefined && curDivAgid != "" && curDivAgid != agendaId) {
            ag_duration += agendaTime;

          }
        });
        newMeetDur = newMeetDur + ag_duration;
        ag_duration = total_mts - ag_duration;
      } else {
        newMeetDur = newMeetDur + ag_duration;
        ag_duration = total_mts;

      }
      newMeetDur = newMeetDur + agTime;


      if (newMeetDur > total_mts) {

        this.dialog.open(ConfirmDialogComponent, {
          data: {
            dialogTitle: "Confirmation",
            dialogContent: environment_msg.msg_confirm_extend_agendaTime
          },
        }).afterClosed().subscribe((response: any) => {
          if (response == true) {
            if (agTime > ag_duration) {
              //var conf = confirm("Agendas time exceeds meeting duration,Still Do you want to add agenda? If Yes,It will extend the meeting duration time. Click on OK to continue..");
              //if(conf){
              $(".mtngdur").val(newMeetDur);
              // updateMeetingTime($(".mtngdur")[0],'');
              var updateMeetingDur = {
                "duration": newMeetDur,
                "meetingStartTime": this.meetingResponse.meetingStartTime,
                "meetingTitle": this.meetingResponse.meetingTitle,
                "meetingDateStr": this.meetingResponse.meetingDateShortFormat,
                "orgCode": this.globals.orgCode,
                "userId": this.globals.userId,
                "visitorTimeZone": this.globals.vTimeZone
              }
              this.meetingService.updateMeeting(this.meetingResponse.meetingId, updateMeetingDur).subscribe(responsedata => {
                var meetingresp = responsedata.body;
                this.meetingResponse.duration = meetingresp.duration
                resolve(agTime);
                this.meetingTime.next(this.meetingResponse.duration);
              });
            }

          }
          else {
            resolve(ag_duration);
          }
        });
      } else {
        resolve(agTime);
      }
    });
  }

  convertEntities(event: any, entityTypeCode: any, obj: HTMLElement, additionalJson: any, divId: any) {
    this.editCollabData = <MinutesCollabDetails>{};
    var minutesService = this.injector.get(FreeFormMinutesService);
    return Promise.resolve((() => {


      var jsonData: any = {};
      var replaceTxt = "";
      var insertAtLast = "N";
      var elem;
      var createNewNote = "";
      var convertMinutes = "";
      var pageIns = this;
      if (additionalJson.replaceText != null && additionalJson.replaceText != "" && additionalJson.replaceText != undefined) {
        replaceTxt = additionalJson.replaceText;
      }
      if (additionalJson.insertAtLast != null && additionalJson.insertAtLast != "" && additionalJson.insertAtLast != undefined) {
        jsonData.insertAtLast = additionalJson.insertAtLast;
      }
      if (additionalJson.isDefaultNotes != null && additionalJson.isDefaultNotes != "" && additionalJson.isDefaultNotes != undefined) {
        jsonData.isDefaultNotes = additionalJson.isDefaultNotes;
      }
      if (additionalJson.isCopied != null && additionalJson.isCopied != "" && additionalJson.isCopied != undefined) {
        jsonData.isCopied = additionalJson.isCopied;
      }
      if (additionalJson.prevnoteType != null && additionalJson.prevnoteType != "" && additionalJson.prevnoteType != undefined) {
        jsonData.prevnoteType = additionalJson.prevnoteType;
      }
      if (additionalJson.noteDescription != null && additionalJson.noteDescription != "" && additionalJson.noteDescription != undefined) {
        jsonData.noteDescription = additionalJson.noteDescription;
      }
      if (additionalJson.minutesId != null && additionalJson.minutesId != "" && additionalJson.minutesId != undefined) {
        jsonData.minutesId = additionalJson.minutesId;
      }
      this.utilService.replaceShortcut(additionalJson, obj, replaceTxt);
      var agId = obj.getAttribute("agId");
      if (agId != null && agId != "" && agId != undefined) {
        jsonData.agendaId = agId;
        if (jsonData != null && jsonData != undefined) {

          this.createEmptyMinutes(jsonData, entityTypeCode, obj, convertMinutes).then((resultData: any) => {
            if (resultData != null && resultData.minutesId != null && resultData.minutesId != "" && resultData.minutesId != undefined) {

              var minId = resultData.minutesId;
              this.pushMinutesConstruction(resultData, obj).then((result: any) => {
                var minId = resultData.minutesId;

                setTimeout(function () {
                  pageIns.updateModernMinutesSeq($("#agMinId" + minId));
                  //$("#agMinId" + minId)[0].focus();
                  //pageIns.utilService.placeCaretAtEnd($("#agMinId" + minId)[0]);
                }, 100000);
                setTimeout(function () {

                  minutesService.removeMinutesFromHover(divId, "Y");


                }, 5);
              });
              pageIns.editCollabData.agElemPosition = pageIns.meetingResponse.agElemPosition;
              pageIns.editCollabData.minElemPosition = pageIns.meetingResponse.minElemPosition;
              pageIns.editCollabData.elementVal = resultData;
              pageIns.editCollabData.collabType = 'MIN';
              pageIns.editCollabData.elementId = resultData.minutesId;
              pageIns.editCollabData.meetingId = pageIns.meetingResponse.meetingId;
              this.callPushMessageToServer(pageIns.editCollabData, obj, 'MIN');
            }
          });
        }
      }
      if (event != undefined && event != null && typeof event.cancel === 'function') {
        event.cancel();
      } else if (event != undefined && event != null && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      //
      return true;
    })());
  }


  trackAgendaEventOnClick(event: any, entityType: any) {
    // var obj = event.target as HTMLElement;
    var obj = event.currentTarget as HTMLElement;

    this.parentAgendaId = "";
    if ($(obj).attr("parentAgId") != null && $(obj).attr("parentAgId") != undefined)
      this.parentAgendaId = $(obj).attr("parentAgId");
    var pageIns = this;
    var sel = window.getSelection && window.getSelection();
    var position = 0;
    var actualText = obj.innerText;
    var actualHtml = obj.innerHTML;
    var curAgendaId = obj.getAttribute("agid");
    var croppedText = "";
    var matchString = "";
    var additionalJson: any = {};
    var lastIndexOfChar = -1;
    var isPreNote = "";
    if (sel && sel.rangeCount > 0) {
      var range = window.getSelection()?.getRangeAt(0);
      position = this.utilService.getCharacterOffsetWithin(range, obj);
    }
    croppedText = actualText.substring(0, position);
    lastIndexOfChar = croppedText.lastIndexOf("/");
    matchString = actualText.substring(lastIndexOfChar, position);
    additionalJson.start = lastIndexOfChar;
    additionalJson.end = position;
    if (matchString != "" && matchString != undefined && (matchString == this.globals.agendaSubCode || matchString == this.globals.agendaSubAtLastCode) && this.globals.addAgendaGlobalRights) {
      this.parentAgendaId = curAgendaId
      entityType = "AG";
    }
    if (entityType == "AG") {
      this.createEmptyAgenda('Y').then((empAgendaDetail: any) => {
        if (empAgendaDetail != null && empAgendaDetail != "" && empAgendaDetail != undefined) {

          if (matchString == this.globals.agendaCode) {
          } else {
            empAgendaDetail.insertAtLast = "Y"
          }
          this.pushAgendaConstruction(empAgendaDetail, obj).then((result: any) => {
            setTimeout(function () {
              var empAgendaId = empAgendaDetail.agendaId;
              $("#meetAgendaId" + empAgendaId).focus();
              //pageIns.updateAgenda($("#meetAgendaId" + curAgendaId), null,'N');
            }, 500);
          });

        }
      });
      event.preventDefault();
      return false;
    } else if (matchString != "" && matchString != undefined && (matchString == this.globals.agDurationCode) && this.globals.editAgendaGlobalRights) {
      this.utilService.replaceShortcut(additionalJson, obj, this.globals.agDurationRegexCode);
      this.checkAgendaDurationExceed(this.globals.defaultAgendaDuration, curAgendaId).then((resp: any) => {
        if ($(obj).find(".agDurCls").length == 0) {
          var durHtml = '<span contenteditable="false" class="agDurCls"><span class="agDurLabelCls">[ </span>' + this.globals.defaultAgendaDuration + '<span class="agDurLabelCls"> Minutes ]</span></span>';
          var conf = true;
          if ($(obj).children().last().prop("tagName") == "BR") {
            $(obj).children().last().remove();
          }
          if (conf) {

            $(obj).append(durHtml);
            this.pushAgendaDuration(curAgendaId, this.globals.defaultAgendaDuration);
            //$("#agendaMainId" + curAgendaId).attr("agendatime", this.globals.defaultAgendaDuration);
          }
        }
        this.utilService.placeCaretAtEnd($(obj)[0]);
        event.preventDefault();
        return false;
      });
    } else if (entityType == "/nn") {
      if (entityType == this.globals.noteCode) {

        additionalJson.replaceText = this.globals.noteRegexCode;
      } else if (matchString == this.globals.noteAtLastCode) {
        additionalJson.replaceText = this.globals.noteAtLastRegexCode;
        additionalJson.insertAtLast = "Y";
      }

      this.midMinutesConstructionOnClick(event, environment.noteEntityType, obj, additionalJson);
    } else if (entityType == "/dd") {
      if (entityType == this.globals.decisionCode) {

        additionalJson.replaceText = this.globals.decisionRegexCode;
      } else if (matchString == this.globals.decisionAtLastCode) {
        additionalJson.replaceText = this.globals.decisionAtLastRegexCode;
        additionalJson.insertAtLast = "Y";
      }
      this.midMinutesConstructionOnClick(event, environment.decisionEntityType, obj, additionalJson);
    } else if (entityType == "/tt") {
      if (entityType == this.globals.taskCode) {

        additionalJson.replaceText = this.globals.taskRegexCode;
      } else if (matchString == this.globals.taskAtLastCode) {
        additionalJson.replaceText = this.globals.taskAtLastRegexCode;
        additionalJson.insertAtLast = "Y";
      }
      this.midMinutesConstructionOnClick(event, environment.taskEntityType, obj, additionalJson);
    } else {
      event.preventDefault();
      return false;
    }

    if (event.which == 64) {
      this.loadTaskAssigneeAndAgPresenter(true, "AG", obj);
    }
    return true;
  }

  midMinutesConstructionOnClick(event: any, entityTypeCode: any, obj: HTMLElement, additionalJson: any) {
    this.editCollabData = <MinutesCollabDetails>{};
    return Promise.resolve((() => {



      var isPreviews = "";
      var jsonData: any = {};
      // var replaceTxt = "";
      var insertAtLast = "N";
      var elem;
      var createNewNote = "";
      var convertMinutes = "";
      var pageIns = this;
      if (additionalJson.replaceText != null && additionalJson.replaceText != "" && additionalJson.replaceText != undefined) {
        // replaceTxt = additionalJson.replaceText;
      }
      if (additionalJson.insertAtLast != null && additionalJson.insertAtLast != "" && additionalJson.insertAtLast != undefined) {
        jsonData.insertAtLast = additionalJson.insertAtLast;
      }
      if (additionalJson.isDefaultNotes != null && additionalJson.isDefaultNotes != "" && additionalJson.isDefaultNotes != undefined) {
        jsonData.isDefaultNotes = additionalJson.isDefaultNotes;
      }
      if (additionalJson.isCopied != null && additionalJson.isCopied != "" && additionalJson.isCopied != undefined) {
        jsonData.isCopied = additionalJson.isCopied;
      }
      if (additionalJson.noteDescription != null && additionalJson.noteDescription != "" && additionalJson.noteDescription != undefined) {
        jsonData.noteDescription = additionalJson.noteDescription;
      }
      if (additionalJson.prevnoteType != null && additionalJson.prevnoteType != "" && additionalJson.prevnoteType != undefined) {
        jsonData.prevnoteType = additionalJson.prevnoteType;
      }


      if ((this.meetingResponse.meetingStartFlag != "Y") && (isPreviews == "" || isPreviews == "Y")) {
        isPreviews = "Y";
        jsonData.isPreviews = isPreviews;


      } else {
        isPreviews = "N";
        jsonData.isPreviews = isPreviews;


      }
      // this.utilService.replaceShortcut(additionalJson, obj, replaceTxt);
      var agId = obj.getAttribute("agId");

      if (this.utilService.nvl(obj.getAttribute("isFollowUpFlag")) == "Y") {
        agId = obj.getAttribute("curAgendaId");
      }
      if (agId != null && agId != "" && agId != undefined) {


        jsonData.agendaId = agId;
        if (jsonData != null && jsonData != undefined) {

          this.createEmptyMinutes(jsonData, entityTypeCode, obj, convertMinutes).then((resultData: any) => {
            if (resultData != null && resultData.minutesId != null && resultData.minutesId != "" && resultData.minutesId != undefined) {

              var minId = resultData.minutesId;
              this.pushMinutesConstruction(resultData, obj).then((result: any) => {
                var minId = resultData.minutesId;

                setTimeout(function () {
                  $("#agMinId" + minId).focus();
                  pageIns.updateModernMinutesSeq($("#agMinId" + minId));
                  pageIns.meetingAgendaList.forEach((agElem: any, agIndex: any) => {
                    if (agElem.agendaId == resultData.agendaId) {
                      pageIns.editCollabData.agElemPosition = agIndex;
                      if (agElem.minutesList != null && agElem.minutesList != undefined) {
                        agElem.minutesList.forEach((minElem: any, minIndex: any) => {
                          if ((minElem.noteId != null && minElem.noteId == resultData.minutesId) || (minElem.decisionId != null && minElem.decisionId == resultData.minutesId) || (minElem.taskId != null && minElem.taskId == resultData.minutesId)) {
                            pageIns.editCollabData.minElemPosition = minIndex;
                          }
                        });
                      }
                    }
                  });


                  pageIns.editCollabData.elementVal = resultData;
                  pageIns.editCollabData.collabType = 'MIN';
                  pageIns.editCollabData.elementId = resultData.minutesId;
                  pageIns.editCollabData.meetingId = pageIns.meetingResponse.meetingId;
                  pageIns.callPushMessageToServer(pageIns.editCollabData, obj, 'MIN');
                  setTimeout(function () {
                    $("#agMinId" + minId).focus();
                    pageIns.utilService.placeCaretAtEnd($("#agMinId" + minId)[0]);
                  }, 500);
                }, 5);
              });
            }
          });
        }
      }
      if (event != undefined && event != null && typeof event.cancel === 'function') {
        event.cancel();
      } else if (event != undefined && event != null && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      //
      return true;
    })());
  }

  public collapAgendaList(obj: any, type: string) {
    // this.collabAgList.meetingId=obj.meeting_id;
    this.collabAgList.meetingId = obj.meetingId;
    this.collabAgList.element = type;
    this.collabAgList.agendaDuration = obj.agendaDuration;
    this.collabAgList.agendaTimerInSeconds = obj.agendaTimerInSeconds
    this.collabAgList.agendaFlag = obj.agendaFlag;
    this.collabAgList.agendaId = obj.agendaId;
    this.collabAgList.collabType = 'AgList';
    this.collabAgList.agendaTraceId = obj.agendaTraceId;

    this.callPushMessageToServer(this.collabAgList, obj, 'AgList');

  }
  public collabAudio(obj: any) {
    this.collabAudioList.meetingId = obj;
    this.collabAudioList.collabType = 'RECORDMEETING';
    const sentUserName = localStorage.getItem("userName");
    if (sentUserName != null && sentUserName != undefined) {
      this.collabAudioList.sentByUserName = sentUserName;
    }
    this.callPushMessageToServer(this.collabAudioList, obj, 'RECORDMEETING');
  }
  rebuildHierarchy() {
    // Initialize a map to store DTOs by id for quick lookup
    this.flattenedDTOs = this.meetingResponse.agendaList
    const dtoMap: { [id: number]: agendaList } = {};
    if (this.flattenedDTOs != undefined) {
      for (let j = 0; j < this.flattenedDTOs.length; j++) {
        let numIndex: number = +this.flattenedDTOs[j].agendaId;
        dtoMap[numIndex] = this.flattenedDTOs[j];
      }
      this.meetingResponse.groupedAgendaList = this.flattenedDTOs?.filter(dto => !dto.parentAgendaId)

        .map(rootDto => this.buildTree(rootDto, dtoMap));
    }

  }

  buildTree(dto: agendaList, dtoMap: { [agendaId: number]: agendaList }): agendaList {
    const children = this.flattenedDTOs?.filter(child => child.parentAgendaId === dto.agendaId);
    if (children != undefined && children.length > 0) {
      dto.subtopics = children.map(child => this.buildTree(child, dtoMap));
    }
    return dto;

  }

  updateAgendaSequence() {
    const agSeqMap: { [key: number]: number } = {};

    this.meetingResponse.agendaList?.forEach((agElem: any, agIndex: number) => {
      agSeqMap[agIndex + 1] = Number(agElem.agendaId);
    });

    const agendaJSONReq = {
      meetingId: this.meetingResponse.meetingId,
      agSeqList: JSON.stringify(agSeqMap),
    };
    this.meetingService.updateAgendaSequence(JSON.stringify(agendaJSONReq)).subscribe(res => {
    });
  }

}


